import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addMonths from 'date-fns/add_months';
import addDays from 'date-fns/add_days';
import {globalfunc} from '../globalfunc.js'
import moment from 'moment';
import CryptoJS from 'crypto-js'
import { getCompany ,getUserAll,getTeamByCompany} from './core/cacheService'
import { DEFAULT_GOAL_QUESTION, DEFAULT_CULTURE_QUESTION, DEFAULT_GOAL_LABELS, DEFAULT_CULTURE_LABELS, DEFAULT_GOAL_TEXT_PREFIXES, DEFAULT_CULTURE_TEXT_PREFIXES } from '../constants/performanceDefaults'
import { getCompanyTimezone, toCompanyDate } from './utils/companyTimezone'

function getGoalLabel(value: number, customLabels?: Record<number, string> | null): string {
  return (customLabels || DEFAULT_GOAL_LABELS)[value] || ''
}

function getCultureLabel(value: number, customLabels?: Record<number, string> | null): string {
  return (customLabels || DEFAULT_CULTURE_LABELS)[value] || ''
}

function getGoalTextPrefix(value: number, customLabels?: Record<number, string> | null): string {
  if (customLabels && customLabels[value]) {
    return customLabels[value] + ' Goals'
  }
  return DEFAULT_GOAL_TEXT_PREFIXES[value] || ''
}

function getCultureTextPrefix(value: number, customLabels?: Record<number, string> | null): string {
  if (customLabels && customLabels[value]) {
    return customLabels[value] + ' Contributes to Values'
  }
  return DEFAULT_CULTURE_TEXT_PREFIXES[value] || ''
}

export default {
    namespaced: true,
    state: {
      datachart: [],
      dataAll: [],
      datateam:{},
      reviewActivity:{completed:0,pending:0,overdue:0},
      avg:{cultuerAdd:0,GoalsProgress:0,Both:0},
      ChartGoalandCuture:{4:{1:0,2:0,3:0,4:0,},
      3:{1:0,2:0,3:0,4:0,},
      2:{1:0,2:0,3:0,4:0,},
      1:{1:0,2:0,3:0,4:0,},
      mex:0},
      tableData:[],
      receiver:[],
      tableDataAll:[],
      reviewActivityOri:{completed:0,pending:0,overdue:0},
      tableDataOri:[],
      avgOri:{cultuerAdd:0,GoalsProgress:0,Both:0},
      ChartGoalandCutureOri:{4:{1:0,2:0,3:0,4:0,},
      3:{1:0,2:0,3:0,4:0,},
      2:{1:0,2:0,3:0,4:0,},
      1:{1:0,2:0,3:0,4:0,},
      mex:0},
      lineChartOri:[],
      organization:[],
      statussSort:false,
      sortBy:'',
      team:[],
      statusTeam:false,
      valueTeam:'',
      loading:true,
      presetlist:[],
      organization1level:{},
      memberInteam:{},
      memberInteamAll:{},
      presetlistAll:[],
      allUser:[],
      member:[],
      loading_preset:false,
      memberInteamAll_master:{},
      organization1level_master:{},
      period:{key:'',startdate:'',enddate:''},
      data_all_Period:{},
      teams:[],
      activeName: 'overview',
      renderComponent: true,
    },
    mutations: {
      setActiveTabs(state: any, obj: any) {
        state.activeName = obj.activeName
        state.renderComponent = obj.renderComponent
      },
      setOrganization(state: any, value: any) {
        state.organization = value
      },
      setdataAll(state: any, value: any) {
        state.dataAll = value
      },
      setdatachart(state: any, value: any) {
        state.datachart = value
      },
      setdatateam(state: any, value: any) {
        state.datateam = value
      },
      setreviewActivity(state: any, value: any) {
        state.reviewActivity = value
      },
      setavg(state: any, value: any) {
        state.avg = value
      },
      setChartGoalandCuture(state: any, value: any) {

        state.ChartGoalandCuture = value
      },
      settableData(state: any, value: any) {
        state.tableData = value
      },
      settableDataAll(state: any, value: any) {
        state.tableDataAll = value
      },
      setloading(state: any, value: any) {
        state.loading = value
      },
      setpresetlist(state: any, value: any) {
      
        state.presetlist = value
      },
      setpresetlistAll(state: any, value: any) {
      
        state.presetlistAll = value
      },
      setOrganization1level(state: any, value: any) {
        state.organization1level = value
      },
      setMemberInteam(state: any, value: any) {
        
        state.memberInteam = value
      },
      setMemberInteamAll(state: any, value: any) {
        state.memberInteamAll = value
      },
      setMemberInteamMaster(state: any, value: any) {
        state.memberInteamAll_master = value
      },
      setAllUser(state: any, value: any) {
        state.allUser = value
      },
      setMember(state: any, value: any) {
        state.member = value
      },
      setloading_preset(state: any, value: any) {
        state.loading_preset = value
      },
      setOrganizationMaster(state: any, value: any) {
        state.organization1level_master = value
      },
      setperiod(state: any, value: any) {
        state.period = value
      },
      setdata_table_Period(state: any, value: any) {
        state.data_all_Period = value
      },
      setteams(state: any, value: any) {
        state.teams= value
      },
    },
    actions: {
      async getOrganization({commit,rootState,dispatch,state}:any, value:any){
        let result={}
        let data:Array<any>=[]
        await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
        .then((querySnapshot)=> {
                querySnapshot.forEach((doc)=> {
                  const team_id=doc.data().team_id
                  result[team_id]=doc.data().parent
                  data.push(doc.data())



                });
                commit('setOrganization', result)
                commit('setOrganizationMaster', data)    
                dispatch('getTeam',value)
                dispatch('getSendReviewGem',value)
            
            

        });
      },
      async getTeam({commit,rootState,dispatch,state}:any, value:any){
        let result:Array<any>=[]
        const organization=state.organization
        
        const allteam =await getTeamByCompany(rootState.authen.user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val() 
        commit('setteams',allteam)
       if(rootState.authen.user.user_type == 'leadership'){
        if(organization[rootState.authen.user.team]){
          for(const key in organization[rootState.authen.user.team]){
            result.push({key: key, name: allteam[key].name})
          }
        }else{
          result.push({key: rootState.authen.user.team, name: allteam[rootState.authen.user.team].name})
        }
        commit('setdatateam', result)


       }else{
        result=[{key: 'All Teams', name: 'All Teams'}]
        for (const i in allteam) {
          allteam[i].key = i
          allteam[i].value = allteam[i].name
          result.push(allteam[i])
        }
    
        commit('setdatateam', result)
       }
       
       
      },
      async changeTeam({commit,rootState,dispatch,state}:any, value:any){
        //console.log('changeTeam',value)
        const timezone = await getCompanyTimezone(rootState.authen.user.company)
        const companyNow = toCompanyDate(new Date(), timezone)
        const teamHeight=rootState.main.teamHeight
        let listTeam:Array<any>=[]
        let todayData:any={cultuerAdd:{value:0,total:0},GoalsProgress:{value:0,total:0},Both:{value:0,total:0}}
        const team_All=await getTeamByCompany(rootState.authen.user.company)//(await firebase.database().ref(`/team`).orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        //const cohortUser=rootState.leaderboards.cohortUser
        let reviewActivity={completed:0,pending:0,overdue:0,total:0}
        //let reviewActivity1={completed:0,goal:0,both:0,culture:0}
        let arrData:any={4:{1:0,2:0,3:0,4:0,},
        3:{1:0,2:0,3:0,4:0,},
        2:{1:0,2:0,3:0,4:0,},
        1:{1:0,2:0,3:0,4:0,},
        mex:0}
        let alluser=rootState.main.allUser
        let tableData:Array<any>=[]
        let family:Array<any> =[]
        const avg={cultuerAdd:{value:0,total:0},GoalsProgress:{value:0,total:0},Both:{value:0,total:0}}
        let calavg={cultuerAdd:'',GoalsProgress:'',Both:''}
        let lineChart:any = {cultuerAdd:[],GoalsProgress:[],Both:[],avg:{cultuerAdd:0,GoalsProgress:0,Both:0}}
        let dataChart={cultuerAdd:{},GoalsProgress:{},Both:{}}
        let _boss =  (await firebase.database().ref(`/boss/${ rootState.authen.user.company}`).once('value')).val()
        const receiver=state.receiver
        const _findAllTeam=_.find(value, function(o) { return o=='All Teams'; });
       
        const period_startdate=state.period.startdate
        const period_enddate=state.period.enddate

        let mount_review=5
        const end_date=state.period.enddate
        const start_date=state.period.startdate
        if(state.period.key==='lastYear'){
            mount_review=11   
        }else if(format(new Date(start_date), 'YYYY-MM')==format(new Date(end_date), 'YYYY-MM')){
          mount_review=0
        }else if(state.period.key==='yearToDate'){
          let count=0
          while(format(addMonths(new Date(start_date),count), 'YYYY-MM')!=format(new Date(end_date), 'YYYY-MM')){
            count++
          }
          mount_review=count
        }else {
          mount_review=5
        }


        

        

      
        if((value.length==1&&value[0]=='All Teams')||((value.length-1)==Object.keys(team_All).length&&_findAllTeam)){
          //console.log('All Teams')
          state.statusTeam=false
          state.valueTeam=''
            reviewActivity=state.reviewActivityOri
            tableData=state.tableDataOri
            arrData=state.ChartGoalandCutureOri
            lineChart=state.lineChartOri
            calavg=state.avgOri

        }else if(value.length==0){

        }else{
          const team_select_all=_.cloneDeep(value)
          for(const i in value){
            if(value[i]!=='All Teams'){

              state.valueTeam=value
              state.statusTeam=true
              const organization=state.organization
              let team_select={}
             
         
          
          // if(organization[value[i]]){ 
          //   if(value[i]==teamHeight){
          //     if(organization[value[i]]){
          //       for(const key in organization[value[i]]){
          //         const find_team=_.find(team_select_all,function(o){return o==key})
          //         if(find_team){
          //           if(!team_select[key]){
          //             team_select[key]=true
          //           }
          //         }
          //       }
          //     }
          //   }else{
          //     team_select=organization[value[i]]
          //   }
          // }else{
          //   team_select={[value[i]]:true}
          // }

          
           //console.log('value',value)
          // console.log('team_select',team_select)
          //for(const team in team_select){
            const team=value[i]
            //console.log('team',team)
            const findTeam=_.find(listTeam, function(o) { return o==team; });
            
            if(!findTeam){
              listTeam.push(team)
              let boss_select = _.filter(_boss, function(o) { return o.team==team; });
              if(boss_select.length>0){
                for(const boss in boss_select){
                  const _tableData=_.filter(  state.tableDataAll, function (b) {return b.email==boss_select[boss].email;});
                  tableData.push(..._tableData)
                }
                
              }

            }    
          //}
          
          }
            
          }




         
          const received=state.receiver
          //console.log('tableData',tableData)
          if(tableData.length>0){
            for(const i in tableData){
              const family=tableData[i].family
              //console.log('family',family)
              for(const key in family){
                reviewActivity.total++
                reviewActivity.completed+=family[key].reviews_status=='Completed'?1:0
                reviewActivity.overdue+=family[key].reviews_status=='Overdue'?1:0
                reviewActivity.pending+=family[key].reviews_status=='Pending'?1:0
                if(family[key].reviews_status=='Completed'||family[key].reviews_status=='Pending'){

                 if(family[key]){
                  if((family[key].goal_Original&&family[key].culture_Original)){
             
                    arrData[family[key].culture_Original][family[key].goal_Original]++
                  }
                 }
                  
                }else {
                  if(family[key].goal_Original&&family[key].culture_Original){
                    arrData[family[key].culture_Original][family[key].goal_Original]++
                  }
                }
                
                if(received[family[key].email]){
                 
                  for(const key1 in received[family[key].email]){
                    
                    const data=received[family[key].email][key1]
                    
                    const month=format(new Date(data.createdate), 'YYYY-MM')
                    if(format(new Date(data.createdate), 'YYYY-MM-DD')>=format(addDays(companyNow,-30), 'YYYY-MM-DD')){
                      if(data.culture){
                       
                        todayData.cultuerAdd.total++
                        todayData.cultuerAdd.value+=data.culture==4||data.culture==3?100:data.culture==2?50:0
                      }
                      if(data.goal){
                        
                        todayData.GoalsProgress.total++
                        todayData.GoalsProgress.value+=data.goal==4||data.goal==3?100:data.goal==2?50:0
                        
                      }
                      if(data.goal&&data.culture){
                        
                        todayData.Both.total++
                        if((data.culture==3||data.culture==4)&&(data.goal==3||data.goal==4)){
                          todayData.Both.value+=100
                        }else{
                          todayData.Both.value+=0
                        }
                     
                      }
                    }
  
                      if(data.culture){
                        if(!dataChart.cultuerAdd[month]){
                          dataChart.cultuerAdd[month]={value:0,total:0}
                        }
                        dataChart.cultuerAdd[month].total++
                        dataChart.cultuerAdd[month].value+=data.culture==4||data.culture==3?100:data.culture==2?50:0
                      }
                      if(data.goal){
                        if(!dataChart.GoalsProgress[month]){
                          dataChart.GoalsProgress[month]={value:0,total:0}
                        }
                        dataChart.GoalsProgress[month].total++
                        dataChart.GoalsProgress[month].value+=data.goal==4||data.goal==3?100:data.goal==2?50:0
                      }
                      if(data.goal&&data.culture){
                        if(!dataChart.Both[month]){
                          dataChart.Both[month]={value:0,total:0}
                        }
                        dataChart.Both[month].total++
                        if((data.culture==3||data.culture==4)&&(data.goal==3||data.goal==4)){
                          dataChart.Both[month].value+=100
                        }else{
                          dataChart.Both[month].value+=0
                        }
                        
                      }
                    
                
                  }
                }
               
              }

            }
           
          }

          const today={
            cultuerAdd:todayData.cultuerAdd?todayData.cultuerAdd.value/todayData.cultuerAdd.total:0,
            GoalsProgress:todayData.GoalsProgress?todayData.GoalsProgress.value/todayData.GoalsProgress.total:0,
            Both:todayData.GoalsProgress?todayData.Both.value/todayData.Both.total:0
          }
  
          const convert_start_date=format(new Date(state.period.startdate), 'YYYY-MM')
          const convert_end_date=format(new Date(state.period.enddate), 'YYYY-MM')
            

        
            if(convert_start_date==convert_end_date){
              //console.log('convert_start_date',convert_start_date)
              for(let i=mount_review;i>=0;i--){

                const month=format(addMonths(new Date(state.period.enddate),-i), 'YYYY-MM')
                //console.log('month',month)
                if(month==convert_start_date){
                 
                  avg.cultuerAdd.value+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value:0
                  avg.cultuerAdd.total+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].total:0
                  avg.GoalsProgress.value+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value:0
                  avg.GoalsProgress.total+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].total:0
                  avg.Both.value+=dataChart.Both[month]?dataChart.Both[month].value:0
                  avg.Both.total+=dataChart.Both[month]?dataChart.Both[month].total:0
                }
                
         
                if(i!=0){
                  if(month==convert_start_date){
                  lineChart.cultuerAdd.push(dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value/dataChart.cultuerAdd[month].total:0)
                  lineChart.GoalsProgress.push(dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value/dataChart.GoalsProgress[month].total:0)
                  lineChart.Both.push(dataChart.Both[month]?dataChart.Both[month].value/dataChart.Both[month].total:0)
                  }else{
                    lineChart.cultuerAdd.push(0)
                    lineChart.GoalsProgress.push(0)
                    lineChart.Both.push(0)
                  }
                }
                if(i==0){
                  if(month==convert_start_date){
                  lineChart.cultuerAdd.push(isNaN(today.cultuerAdd)?0:today.cultuerAdd)
                  lineChart.GoalsProgress.push(isNaN(today.GoalsProgress)?0:today.GoalsProgress)
                  lineChart.Both.push(isNaN(today.Both)?0:today.Both)
                  calavg.cultuerAdd=isNaN(avg.cultuerAdd.value/avg.cultuerAdd.total)?'0':(avg.cultuerAdd.value/avg.cultuerAdd.total).toFixed()
                  calavg.GoalsProgress=isNaN(avg.GoalsProgress.value/avg.GoalsProgress.total)?'0':(avg.GoalsProgress.value/avg.GoalsProgress.total).toFixed()
                  calavg.Both=isNaN(avg.Both.value/avg.Both.total)?'0':(avg.Both.value/avg.Both.total).toFixed()
                  }else{
                    lineChart.cultuerAdd.push(0)
                    lineChart.GoalsProgress.push(0)
                    lineChart.Both.push(0)
                    calavg.cultuerAdd=isNaN(avg.cultuerAdd.value/avg.cultuerAdd.total)?'0':(avg.cultuerAdd.value/avg.cultuerAdd.total).toFixed()
                    calavg.GoalsProgress=isNaN(avg.GoalsProgress.value/avg.GoalsProgress.total)?'0':(avg.GoalsProgress.value/avg.GoalsProgress.total).toFixed()
                    calavg.Both=isNaN(avg.Both.value/avg.Both.total)?'0':(avg.Both.value/avg.Both.total).toFixed()
                  }
                }
    
              }
            }else{
            for(let i=mount_review;i>=0;i--){
              
              const month=format(addMonths(new Date(state.period.enddate),-i), 'YYYY-MM')
              
              if(month>=period_startdate&&month<=period_enddate){
                //console.log('month[[[[[]]]]]',month)
                avg.cultuerAdd.value+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value:0
                avg.cultuerAdd.total+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].total:0
                avg.GoalsProgress.value+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value:0
                avg.GoalsProgress.total+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].total:0
                avg.Both.value+=dataChart.Both[month]?dataChart.Both[month].value:0
                avg.Both.total+=dataChart.Both[month]?dataChart.Both[month].total:0

              }
             
       
              if(i!=0){
                if(month>=period_startdate&&month<=period_enddate){
                  lineChart.cultuerAdd.push(dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value/dataChart.cultuerAdd[month].total:0)
                  lineChart.GoalsProgress.push(dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value/dataChart.GoalsProgress[month].total:0)
                  lineChart.Both.push(dataChart.Both[month]?dataChart.Both[month].value/dataChart.Both[month].total:0)
                }else{
                  lineChart.cultuerAdd.push(0)
                  lineChart.GoalsProgress.push(0)
                  lineChart.Both.push(0)
                }
              }
              if(i==0){
                if(month>=period_startdate&&month<=period_enddate){
                  lineChart.cultuerAdd.push(isNaN(today.cultuerAdd)?0:today.cultuerAdd)
                  lineChart.GoalsProgress.push(isNaN(today.GoalsProgress)?0:today.GoalsProgress)
                  lineChart.Both.push(isNaN(today.Both)?0:today.Both)
                  calavg.cultuerAdd=isNaN(avg.cultuerAdd.value/avg.cultuerAdd.total)?'0':(avg.cultuerAdd.value/avg.cultuerAdd.total).toFixed()
                  calavg.GoalsProgress=isNaN(avg.GoalsProgress.value/avg.GoalsProgress.total)?'0':(avg.GoalsProgress.value/avg.GoalsProgress.total).toFixed()
                  calavg.Both=isNaN(avg.Both.value/avg.Both.total)?'0':(avg.Both.value/avg.Both.total).toFixed()

                }else{
                  lineChart.cultuerAdd.push(0)
                  lineChart.GoalsProgress.push(0)
                  lineChart.Both.push(0)
                  calavg.cultuerAdd='0'
                  calavg.GoalsProgress='0'
                  calavg.Both='0'
                }
              
              }
  
            }

          }

          


          // if(state.period.key=='last3months'||state.period.key=='last6months'){
          //   for(let i=mount_show;i>=0;i--){

          //     const month=format(addMonths(new Date(),-i), 'YYYY-MM')
          //     console.log('month',month)
          //     if(month>=period_startdate&&month<=period_enddate){
          //       console.log('month[[[[[]]]]]',month)
          //       avg.cultuerAdd.value+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value:0
          //       avg.cultuerAdd.total+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].total:0
          //       avg.GoalsProgress.value+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value:0
          //       avg.GoalsProgress.total+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].total:0
          //       avg.Both.value+=dataChart.Both[month]?dataChart.Both[month].value:0
          //       avg.Both.total+=dataChart.Both[month]?dataChart.Both[month].total:0

          //     }
             
       
          //     if(i!=0){
          //       if(month>=period_startdate&&month<=period_enddate){
          //         lineChart.cultuerAdd.push(dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value/dataChart.cultuerAdd[month].total:0)
          //         lineChart.GoalsProgress.push(dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value/dataChart.GoalsProgress[month].total:0)
          //         lineChart.Both.push(dataChart.Both[month]?dataChart.Both[month].value/dataChart.Both[month].total:0)
          //       }else{
          //         lineChart.cultuerAdd.push(0)
          //         lineChart.GoalsProgress.push(0)
          //         lineChart.Both.push(0)
          //       }
          //     }
          //     if(i==0){
          //       if(month>=period_startdate&&month<=period_enddate){
          //         lineChart.cultuerAdd.push(isNaN(today.cultuerAdd)?0:today.cultuerAdd)
          //         lineChart.GoalsProgress.push(isNaN(today.GoalsProgress)?0:today.GoalsProgress)
          //         lineChart.Both.push(isNaN(today.Both)?0:today.Both)
          //         calavg.cultuerAdd=isNaN(avg.cultuerAdd.value/avg.cultuerAdd.total)?'0':(avg.cultuerAdd.value/avg.cultuerAdd.total).toFixed()
          //         calavg.GoalsProgress=isNaN(avg.GoalsProgress.value/avg.GoalsProgress.total)?'0':(avg.GoalsProgress.value/avg.GoalsProgress.total).toFixed()
          //         calavg.Both=isNaN(avg.Both.value/avg.Both.total)?'0':(avg.Both.value/avg.Both.total).toFixed()

          //       }else{
          //         lineChart.cultuerAdd.push(0)
          //         lineChart.GoalsProgress.push(0)
          //         lineChart.Both.push(0)
          //         calavg.cultuerAdd='0'
          //         calavg.GoalsProgress='0'
          //         calavg.Both='0'
          //       }
              
          //     }
  
          //   }



          // }else{
          //   const convert_start_date=format(new Date(state.period.startdate), 'YYYY-MM')
          //   const convert_end_date=format(new Date(state.period.enddate), 'YYYY-MM')
          //   console.log('convert_start_date',convert_start_date)
          //   console.log('convert_end_date',convert_end_date)
          //   if(convert_start_date==convert_end_date){
          //     console.log('convert_start_date',convert_start_date)
          //     for(let i=mount_show;i>=0;i--){

          //       const month=format(addMonths(new Date(),-i), 'YYYY-MM')
          //       console.log('month',month)
          //       if(month==convert_start_date){
          //         console.log('month',month)
          //         avg.cultuerAdd.value+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value:0
          //         avg.cultuerAdd.total+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].total:0
          //         avg.GoalsProgress.value+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value:0
          //         avg.GoalsProgress.total+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].total:0
          //         avg.Both.value+=dataChart.Both[month]?dataChart.Both[month].value:0
          //         avg.Both.total+=dataChart.Both[month]?dataChart.Both[month].total:0
          //       }
                
         
          //       if(i!=0){
          //         if(month==convert_start_date){
          //         lineChart.cultuerAdd.push(dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value/dataChart.cultuerAdd[month].total:0)
          //         lineChart.GoalsProgress.push(dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value/dataChart.GoalsProgress[month].total:0)
          //         lineChart.Both.push(dataChart.Both[month]?dataChart.Both[month].value/dataChart.Both[month].total:0)
          //         }else{
          //           lineChart.cultuerAdd.push(0)
          //           lineChart.GoalsProgress.push(0)
          //           lineChart.Both.push(0)
          //         }
          //       }
          //       if(i==0){
          //         if(month==convert_start_date){
          //         lineChart.cultuerAdd.push(isNaN(today.cultuerAdd)?0:today.cultuerAdd)
          //         lineChart.GoalsProgress.push(isNaN(today.GoalsProgress)?0:today.GoalsProgress)
          //         lineChart.Both.push(isNaN(today.Both)?0:today.Both)
          //         calavg.cultuerAdd=isNaN(avg.cultuerAdd.value/avg.cultuerAdd.total)?'0':(avg.cultuerAdd.value/avg.cultuerAdd.total).toFixed()
          //         calavg.GoalsProgress=isNaN(avg.GoalsProgress.value/avg.GoalsProgress.total)?'0':(avg.GoalsProgress.value/avg.GoalsProgress.total).toFixed()
          //         calavg.Both=isNaN(avg.Both.value/avg.Both.total)?'0':(avg.Both.value/avg.Both.total).toFixed()
          //         }else{
          //           lineChart.cultuerAdd.push(0)
          //           lineChart.GoalsProgress.push(0)
          //           lineChart.Both.push(0)
          //           calavg.cultuerAdd=isNaN(avg.cultuerAdd.value/avg.cultuerAdd.total)?'0':(avg.cultuerAdd.value/avg.cultuerAdd.total).toFixed()
          //           calavg.GoalsProgress=isNaN(avg.GoalsProgress.value/avg.GoalsProgress.total)?'0':(avg.GoalsProgress.value/avg.GoalsProgress.total).toFixed()
          //           calavg.Both=isNaN(avg.Both.value/avg.Both.total)?'0':(avg.Both.value/avg.Both.total).toFixed()
          //         }
          //       }
    
          //     }
          //   }


          //   // for(let i=mount_show;i>=0;i--){

          //   //   const month=format(addMonths(new Date(),-i), 'YYYY-MM')
          //   //   console.log('month',month)
          //   //   avg.cultuerAdd.value+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value:0
          //   //   avg.cultuerAdd.total+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].total:0
          //   //   avg.GoalsProgress.value+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value:0
          //   //   avg.GoalsProgress.total+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].total:0
          //   //   avg.Both.value+=dataChart.Both[month]?dataChart.Both[month].value:0
          //   //   avg.Both.total+=dataChart.Both[month]?dataChart.Both[month].total:0
       
          //   //   if(i!=0){
          //   //     lineChart.cultuerAdd.push(dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value/dataChart.cultuerAdd[month].total:0)
          //   //     lineChart.GoalsProgress.push(dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value/dataChart.GoalsProgress[month].total:0)
          //   //     lineChart.Both.push(dataChart.Both[month]?dataChart.Both[month].value/dataChart.Both[month].total:0)
          //   //   }
          //   //   if(i==0){
          //   //     lineChart.cultuerAdd.push(isNaN(today.cultuerAdd)?0:today.cultuerAdd)
          //   //     lineChart.GoalsProgress.push(isNaN(today.GoalsProgress)?0:today.GoalsProgress)
          //   //     lineChart.Both.push(isNaN(today.Both)?0:today.Both)
          //   //     calavg.cultuerAdd=isNaN(avg.cultuerAdd.value/avg.cultuerAdd.total)?'0':(avg.cultuerAdd.value/avg.cultuerAdd.total).toFixed()
          //   //     calavg.GoalsProgress=isNaN(avg.GoalsProgress.value/avg.GoalsProgress.total)?'0':(avg.GoalsProgress.value/avg.GoalsProgress.total).toFixed()
          //   //     calavg.Both=isNaN(avg.Both.value/avg.Both.total)?'0':(avg.Both.value/avg.Both.total).toFixed()
          //   //   }
  
          //   // }

          // }
          
          
         
          for(const key in arrData){
            for(const key2 in arrData[key]){
              if(arrData[key][key2]>= arrData.mex){
                arrData.mex=arrData[key][key2]
              }
            }
          }





           


          

            

        }
        
       
        tableData=_.orderBy(tableData, function(dateObj) {return parseInt( dateObj.reviewCompleted)},['desc'])
        //tableData=_.orderBy(tableData, function(dateObj) {return dateObj.firstname},['asc'])
       
        commit('setreviewActivity',reviewActivity)
        commit('settableData',tableData)
        commit('setChartGoalandCuture',arrData)
        commit('setdatachart',lineChart)
        commit('setavg',calavg)
        if(state.statussSort==true){
     
          dispatch('sortbydata',state.sortBy).then(() => {
           
            commit('setloading', false)
          })
        }else{
          commit('setloading', false)
        }

        


      },
      async getSendReviewGem({dispatch,commit,rootState,state}:any, user:any){
        
        commit('setreviewActivity',{completed:0,pending:0,overdue:0})
        commit('setdatachart',[])
        commit('setavg',{cultuerAdd:0,GoalsProgress:0,Both:0})
        commit('setChartGoalandCuture',{4:{1:0,2:0,3:0,4:0,},
          3:{1:0,2:0,3:0,4:0,},
          2:{1:0,2:0,3:0,4:0,},
          1:{1:0,2:0,3:0,4:0,},
          mex:0})
        commit('settableData',[])
        commit('setloading', true)
        const timezone = await getCompanyTimezone(rootState.authen.user.company)
        const companyNow = toCompanyDate(new Date(), timezone)
        const past7month=format(addMonths(companyNow,-6), 'YYYY-MM')
        const enddate=format(companyNow, 'YYYY-MM-DD')
        const data_all_Period=_.cloneDeep(state.data_all_Period)
       //console.log('past7month',past7month)
        const dataAll:Array<any>=[]
        const reviewActivity={completed:0,pending:0,overdue:0,total:0}

        const arrData:any={4:{1:0,2:0,3:0,4:0,},
        3:{1:0,2:0,3:0,4:0,},
        2:{1:0,2:0,3:0,4:0,},
        1:{1:0,2:0,3:0,4:0,},
        mex:0}
        const team=rootState.main.allTeam
        const alluser=_.cloneDeep(rootState.main.allUser)
        let todayData:any={cultuerAdd:{value:0,total:0},GoalsProgress:{value:0,total:0},Both:{value:0,total:0}}
        const company = await getCompany(rootState.authen.user.company)
        //console.log('company',company)
        let lineChart:any = {cultuerAdd:[],GoalsProgress:[],Both:[],avg:{cultuerAdd:0,GoalsProgress:0,Both:0}}
        let dataChart={cultuerAdd:{},GoalsProgress:{},Both:{}}
        let mount_review=5
        const end_date=state.period.enddate
        const start_date=state.period.startdate
        if(state.period.key==='lastYear'){
            mount_review=11   
        }else if(format(new Date(start_date), 'YYYY-MM')==format(new Date(end_date), 'YYYY-MM')){
          mount_review=0
        }else if(state.period.key==='yearToDate'){
          let count=0
          while(format(addMonths(new Date(start_date),count), 'YYYY-MM')!=format(new Date(end_date), 'YYYY-MM')){
            count++
          }
          mount_review=count
        }else {
          mount_review=5
        }
        if(format(new Date(state.period.startdate), 'YYYY-MM-DD')<format(new Date(past7month), 'YYYY-MM-DD')){

        
          firebase.firestore().collection('send_review_gem').where("company", "==", rootState.authen.user.company).where('createdate','>=',state.period.startdate).where('createdate','<=',state.period.enddate+' 23:59:59').get()
          .then(function (querySnapshot) {
            querySnapshot.forEach((doc) => {
              const data = doc.data()
              data.review_id=doc.id
              let month=format(new Date(data.createdate), 'YYYY-MM')
              if(!isNaN(data.culture)&&!isNaN(data.goal)){

              
              dataAll.push(data)
              if(format(new Date(data.createdate), 'YYYY-MM-DD')>=format(addDays(companyNow,-30), 'YYYY-MM-DD')){
                if(data.culture){
                
                  todayData.cultuerAdd.total++
                  todayData.cultuerAdd.value+=data.culture==4||data.culture==3?100:data.culture==2?50:0
                }
                if(data.goal){
                  
                  todayData.GoalsProgress.total++
                  todayData.GoalsProgress.value+=data.goal==4||data.goal==3?100:data.goal==2?50:0
                  
                }
                if(data.goal&&data.culture){
                  
                  todayData.Both.total++
                  if((data.culture==3||data.culture==4)&&(data.goal==3||data.goal==4)){
                    todayData.Both.value+=100
                  }else{
                    todayData.Both.value+=0
                  }
              
                }
              }
                if(data.culture){
                  if(!dataChart.cultuerAdd[month]){
                    dataChart.cultuerAdd[month]={value:0,total:0}
                  }
                  dataChart.cultuerAdd[month].total++
                  dataChart.cultuerAdd[month].value+=data.culture==4||data.culture==3?100:data.culture==2?50:0
                }
                if(data.goal){
                  if(!dataChart.GoalsProgress[month]){
                    dataChart.GoalsProgress[month]={value:0,total:0}
                  }
                  dataChart.GoalsProgress[month].total++
                  dataChart.GoalsProgress[month].value+=data.goal==4||data.goal==3?100:data.goal==2?50:0
                  
                }
                if(data.goal&&data.culture){
                  if(!dataChart.Both[month]){
                    dataChart.Both[month]={value:0,total:0}
                  }
                  dataChart.Both[month].total++
                  if((data.culture==3||data.culture==4)&&(data.goal==3||data.goal==4)){
                    dataChart.Both[month].value+=100
                  }else{
                    dataChart.Both[month].value+=0
                  }
                  //arrData[data.culture][data.goal]++
                }



            }
              

            })
            
            const  receiver = _.groupBy(dataAll, function (b) {
              return b.receiver;
            });
            
           
            for(const emailKey in alluser){
              reviewActivity.total++
              if(receiver[alluser[emailKey].email]){
                const newData =_.orderBy(receiver[alluser[emailKey].email], function(dateObj) {
                  return new Date(dateObj.createdate);
                },['desc'])
              
                if(newData){
                
                  const lastData = newData[0]
                  alluser[emailKey].track=[]
                  alluser[emailKey].date_review=lastData.createdate

                  

                  //track
                  for(let i=mount_review;i>=0;i--){
                    //console.log('track',end_date)
                    let track={month:'',track:'',text:'',text1:'',review_id:'',goal_value:'',culture_value:'',goal_ratings:[] as any[],status_filter:false}
                    
                    const month=format(addMonths(new Date(end_date),-i), 'YYYY-MM')
                    //console.log('track',month)
                    //console.log('====month=====',month)
                    const findData= _.find(newData, function(o) {
                      return format(new Date(o.createdate), 'YYYY-MM')==month
                    })
                    track.month=format(addMonths(new Date(end_date),-i), 'MMMM YYYY')
                    if(findData){
                      track.review_id=findData.review_id
                      track.text=getGoalTextPrefix(findData.goal)+': '+findData.goal_value
                      track.goal_value=getGoalLabel(findData.goal)
                      track.goal_ratings=findData.goal_ratings || []

                      track.text1=getCultureTextPrefix(findData.culture)+': '+findData.culture_value
                      track.culture_value=getCultureLabel(findData.culture)

                      if((findData.culture==3||findData.culture==4)&&(findData.goal==3||findData.goal==4)){
                        track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_pink_gem_28.png?alt=media&token=fcbe2996-f5b9-4eec-8b4b-aceed3f39a74')
                      
                      }else{
                        track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_gray_gem_28.png?alt=media&token=a37d9466-4c58-410e-8b60-bddeaae43dc0')
                      
                      }
                    }else{
                      track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                      track.text='No performance boost provided this month'
                    }
                    //console.log('track',track)
                    alluser[emailKey].track.push(track)
                  }

                  
                  if(lastData.goal){
                    alluser[emailKey].goalText=getGoalLabel(lastData.goal)
                    alluser[emailKey].goal_Original=lastData.goal
                  }
                  if(lastData.culture){
                    alluser[emailKey].cultureText=getCultureLabel(lastData.culture)
                    alluser[emailKey].culture_Original=lastData.culture
                  }

                                
                  const time_peding=company.performance_review&&company.performance_review.pending?company.performance_review.pending:1
                  const time_overdue=company.performance_review&&company.performance_review.overdue?company.performance_review.overdue:2

                  
                    alluser[emailKey].reviews_status='-'
                    arrData[lastData.culture][lastData.goal]++
                    alluser[emailKey].goal_Original=lastData.goal
                    alluser[emailKey].goal=lastData.goal==4||lastData.goal==3?100:lastData.goal==2?50:0
  
                    alluser[emailKey].culture_Original=lastData.culture
                    alluser[emailKey].culture=lastData.culture==4||lastData.culture==3?100:lastData.culture==2?50:0
  
  
                      if(lastData.goal&&lastData.culture){
                        if((lastData.culture==3||lastData.culture==4)&&(lastData.goal==3||lastData.goal==4)){
                          alluser[emailKey].both=100
                        }else{
                          alluser[emailKey].both=0
                        }
                      }  

                }
                
                
                else{
                 
                  
                  alluser[emailKey].reviews_status='-'
                  alluser[emailKey].track=[]
                  alluser[emailKey].goalText=''
                  alluser[emailKey].cultureText=''
                  alluser[emailKey].both=0
                  alluser[emailKey].goal=0
                  alluser[emailKey].culture=0

                  for(let i=mount_review;i>=0;i--){
                    let track={month:'',track:'',text:'',text1:'',goal_value:'',culture_value:'',goal_ratings:[] as any[],status_filter:false}
                    const month=format(addMonths(new Date(end_date),-i), 'YYYY-MM')
                    const findData= _.find(newData, function(o) {
                      return format(new Date(o.createdate), 'YYYY-MM')==month
                    })
                    track.month=format(addMonths(new Date(end_date),-i), 'MMMM YYYY')
                    if(findData){

                      track.text=getGoalTextPrefix(findData.goal)+': '+findData.goal_value
                      track.goal_value=getGoalLabel(findData.goal)
                      track.goal_ratings=findData.goal_ratings || []

                      track.text1=getCultureTextPrefix(findData.culture)+': '+findData.culture_value
                      track.culture_value=getCultureLabel(findData.culture)

                      if((findData.culture==3||findData.culture==4)&&(findData.goal==3||findData.goal==4)){
                        track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_pink_gem_28.png?alt=media&token=fcbe2996-f5b9-4eec-8b4b-aceed3f39a74')
                      
                      }else{
                        track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_gray_gem_28.png?alt=media&token=a37d9466-4c58-410e-8b60-bddeaae43dc0')
                      
                      }
                    }else{
                      track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                      track.text='No performance boost provided this month'
                    }
                    alluser[emailKey].track.push(track)
                  }


                }
              }
              
              
              else{
                const time_peding=company.performance_review&&company.performance_review.pending?company.performance_review.pending:1
                const time_overdue=company.performance_review&&company.performance_review.overdue?company.performance_review.overdue:2
                alluser[emailKey].reviews_status='-'
               
                alluser[emailKey].track=[]
                  for(let i=mount_review;i>=0;i--){
                    let track={month:'',track:'',text:'',text1:'',goal_value:'',culture_value:'',goal_ratings:[] as any[],status_filter:false}
                    track.month=format(addMonths(new Date(end_date),-i), 'MMMM YYYY')
                    track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                    track.text='No performance boost provided this month'
                    alluser[emailKey].track.push(track)
                }
              }
            }

            let tableData:Array<any>=[]
            let family:Array<any> =[]
            let cultuerAdd:number=0
            let reviewCompleted:number=0
            let GoalsProgress:number=0
            let both:number=0
            let boss = _.groupBy(alluser, function (b) {
              return b.boss;
            });
            for(const key in boss){
              family=[]
              GoalsProgress=0
              cultuerAdd=0
              both=0
              reviewCompleted=0
              if(key!='undefined'){
                for(const key2 in boss[key]){                
                  boss[key][key2].team_name= team[boss[key][key2].team]&&team[boss[key][key2].team].name?team[boss[key][key2].team].name:'',
                  GoalsProgress+=boss[key][key2].goal?boss[key][key2].goal:0
                  boss[key][key2].goal_Original=boss[key][key2].goal_Original?boss[key][key2].goal_Original:0
                  boss[key][key2].culture_Original=boss[key][key2].culture_Original?boss[key][key2].culture_Original:0
                  cultuerAdd+=boss[key][key2].culture?boss[key][key2].culture:0
                  reviewCompleted+=boss[key][key2].reviews_status=='Completed'?100:0
                  reviewCompleted+=boss[key][key2].reviews_status=='Pending'?100:0
                  both+=boss[key][key2].both?boss[key][key2].both:0
                  let user_email=boss[key][key2].email
                  const ciphertext = CryptoJS.AES.encrypt(user_email, 'performance-summary-report').toString();
                  const url = 'https://insights.happily.ai/performance-summary-report/'+encodeURIComponent(ciphertext);
                  boss[key][key2].link=url
                  
                  family.push(boss[key][key2])
                }
                const emailKey=key.replace(/\./g, "||")
                // console.log('alluser[emailKey]s',alluser[emailKey])
                if(alluser[emailKey]){
                  tableData.push({
                    
                    profilepic_crop:alluser[emailKey].profilepic_crop?alluser[emailKey].profilepic_crop:'',
                    firstname: alluser[emailKey].firstname? alluser[emailKey].firstname:'',
                    lastname:  alluser[emailKey].lastname? alluser[emailKey].lastname:'',
                    team_name: team[ alluser[emailKey].team]?team[ alluser[emailKey].team].name:'',
                    email:  alluser[emailKey].email? alluser[emailKey].email:'',
                    reviewCompleted:(reviewCompleted/boss[key].length).toFixed(),
                    GoalsProgress:(GoalsProgress/boss[key].length).toFixed(),
                    cultuerAdd:(cultuerAdd/boss[key].length).toFixed(),
                    both:(both/boss[key].length).toFixed(),
                    family:family
                  })
                }
                
              }
            
            }

            const avg={cultuerAdd:{value:0,total:0},GoalsProgress:{value:0,total:0},Both:{value:0,total:0}}
            let calavg={cultuerAdd:'',GoalsProgress:'',Both:''}
    
            const today={
              cultuerAdd:todayData.cultuerAdd?todayData.cultuerAdd.value/todayData.cultuerAdd.total:0,
              GoalsProgress:todayData.GoalsProgress?todayData.GoalsProgress.value/todayData.GoalsProgress.total:0,
              Both:todayData.GoalsProgress?todayData.Both.value/todayData.Both.total:0
            }


         
            for(let i=mount_review;i>=0;i--){
              const month=format(addMonths(new Date(end_date),-i), 'YYYY-MM')
              //console.log('month_linechart',month)
              avg.cultuerAdd.value+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value:0
              avg.cultuerAdd.total+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].total:0
              avg.GoalsProgress.value+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value:0
              avg.GoalsProgress.total+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].total:0
              avg.Both.value+=dataChart.Both[month]?dataChart.Both[month].value:0
              avg.Both.total+=dataChart.Both[month]?dataChart.Both[month].total:0
              //if(i!=0){
                lineChart.cultuerAdd.push(dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value/dataChart.cultuerAdd[month].total:0)
                lineChart.GoalsProgress.push(dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value/dataChart.GoalsProgress[month].total:0)
                lineChart.Both.push(dataChart.Both[month]?dataChart.Both[month].value/dataChart.Both[month].total:0)
              //}
              
              if(i==0){
                
                // lineChart.cultuerAdd.push(isNaN(today.cultuerAdd)?0:today.cultuerAdd)
                // lineChart.GoalsProgress.push(isNaN(today.GoalsProgress)?0:today.GoalsProgress)
                // lineChart.Both.push(isNaN(today.Both)?0:today.Both)
                calavg.cultuerAdd=isNaN(avg.cultuerAdd.value/avg.cultuerAdd.total)?'0':(avg.cultuerAdd.value/avg.cultuerAdd.total).toFixed()
                calavg.GoalsProgress=isNaN(avg.GoalsProgress.value/avg.GoalsProgress.total)?'0':(avg.GoalsProgress.value/avg.GoalsProgress.total).toFixed()
                calavg.Both=isNaN(avg.Both.value/avg.Both.total)?'0':(avg.Both.value/avg.Both.total).toFixed()
              }

            }


            for(const key in arrData){
              for(const key2 in arrData[key]){
                if(arrData[key][key2]>= arrData.mex){
                  arrData.mex=arrData[key][key2]
                }
              }
            }

            tableData=_.orderBy(tableData, function(dateObj) {return parseInt( dateObj.GoalsProgress)},['desc'])
            //tableData=_.orderBy(tableData, function(dateObj) {return dateObj.firstname},['asc'])
            
            state.reviewActivityOri=reviewActivity
            state.tableDataOri=tableData
            state.ChartGoalandCutureOri=arrData
            state.lineChartOri=lineChart
            state.avgOri=calavg

        
            if(!data_all_Period[state.period.key]){
              data_all_Period[state.period.key]=dataAll
            }
            //commit('setreviewActivity',reviewActivity)
            //commit('setdatachart',lineChart)
            //commit('setavg',calavg)
            //commit('setChartGoalandCuture',arrData)
            //commit('settableData',tableData)
           
            commit('setdata_table_Period',data_all_Period)
            commit('settableDataAll',tableData)
            //commit('setloading', false)

            
           
            if(state.statusTeam==true){
              dispatch('changeTeam',state.valueTeam)
            }else{
              commit('setreviewActivity',reviewActivity)
              commit('setdatachart',lineChart)
              commit('setavg',calavg)
              commit('setChartGoalandCuture',arrData)
              commit('settableData',tableData)
              //commit('setdataAll',dataAll)
              commit('settableDataAll',tableData)
              commit('setloading', false)

            }
            
      


          })


        }
        else{
          firebase.firestore().collection('send_review_gem').where("company", "==", rootState.authen.user.company).where('createdate','>=',`${past7month}-01`).where('createdate','<=',enddate+' 23:59:59').get()
          .then(function (querySnapshot) {
            querySnapshot.forEach((doc) => {
              const data = doc.data()
              data.review_id=doc.id
              let month=format(new Date(data.createdate), 'YYYY-MM')
              if(!isNaN(data.culture)&&!isNaN(data.goal)){

              
              dataAll.push(data)
              if(format(new Date(data.createdate), 'YYYY-MM-DD')>=format(addDays(companyNow,-30), 'YYYY-MM-DD')){
                if(data.culture){
                
                  todayData.cultuerAdd.total++
                  todayData.cultuerAdd.value+=data.culture==4||data.culture==3?100:data.culture==2?50:0
                }
                if(data.goal){
                  
                  todayData.GoalsProgress.total++
                  todayData.GoalsProgress.value+=data.goal==4||data.goal==3?100:data.goal==2?50:0
                  
                }
                if(data.goal&&data.culture){
                  
                  todayData.Both.total++
                  if((data.culture==3||data.culture==4)&&(data.goal==3||data.goal==4)){
                    todayData.Both.value+=100
                  }else{
                    todayData.Both.value+=0
                  }
              
                }
              }
                if(data.culture){
                  if(!dataChart.cultuerAdd[month]){
                    dataChart.cultuerAdd[month]={value:0,total:0}
                  }
                  dataChart.cultuerAdd[month].total++
                  dataChart.cultuerAdd[month].value+=data.culture==4||data.culture==3?100:data.culture==2?50:0
                }
                if(data.goal){
                  if(!dataChart.GoalsProgress[month]){
                    dataChart.GoalsProgress[month]={value:0,total:0}
                  }
                  dataChart.GoalsProgress[month].total++
                  dataChart.GoalsProgress[month].value+=data.goal==4||data.goal==3?100:data.goal==2?50:0
                  
                }
                if(data.goal&&data.culture){
                  if(!dataChart.Both[month]){
                    dataChart.Both[month]={value:0,total:0}
                  }
                  dataChart.Both[month].total++
                  if((data.culture==3||data.culture==4)&&(data.goal==3||data.goal==4)){
                    dataChart.Both[month].value+=100
                  }else{
                    dataChart.Both[month].value+=0
                  }
                  //arrData[data.culture][data.goal]++
                }



            }
              

            })
            //console.log('dataChart',dataChart)
            const  receiver = _.groupBy(dataAll, function (b) {
              return b.receiver;
            });
            state.receiver=receiver
            for(const emailKey in alluser){
              reviewActivity.total++
              if(receiver[alluser[emailKey].email]){
                const newData =_.orderBy(receiver[alluser[emailKey].email], function(dateObj) {
                  return new Date(dateObj.createdate);
                },['desc'])
              
                if(newData){
                
                  const lastData = newData[0]
                  alluser[emailKey].track=[]
                  alluser[emailKey].date_review=lastData.createdate

                  //track
                  for(let i=5;i>=0;i--){
                    let track={month:'',track:'',text:'',text1:'',review_id:'',goal_value:'',culture_value:'',goal_ratings:[] as any[],status_filter:false}
                    
                    const month=format(addMonths(companyNow,-i), 'YYYY-MM')
                    //console.log('month',month)
                    const findData= _.find(newData, function(o) {
                      return format(new Date(o.createdate), 'YYYY-MM')==month
                    })
                    track.month=format(addMonths(companyNow,-i), 'MMMM YYYY')
                    if(findData){
                      track.review_id=findData.review_id
                      track.text=getGoalTextPrefix(findData.goal)+': '+findData.goal_value
                      track.goal_value=getGoalLabel(findData.goal)
                      track.goal_ratings=findData.goal_ratings || []

                      track.text1=getCultureTextPrefix(findData.culture)+': '+findData.culture_value
                      track.culture_value=getCultureLabel(findData.culture)

                      if((findData.culture==3||findData.culture==4)&&(findData.goal==3||findData.goal==4)){
                        track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_pink_gem_28.png?alt=media&token=fcbe2996-f5b9-4eec-8b4b-aceed3f39a74')
                      
                      }else{
                        track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_gray_gem_28.png?alt=media&token=a37d9466-4c58-410e-8b60-bddeaae43dc0')
                      
                      }
                    }else{
                      track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                      track.text='No performance boost provided this month'
                    }
                    //console.log('track',track)
                    alluser[emailKey].track.push(track)
                  }


                  if(lastData.goal){
                    alluser[emailKey].goalText=getGoalLabel(lastData.goal)
                    alluser[emailKey].goal_Original=lastData.goal
                  }
                  if(lastData.culture){
                    alluser[emailKey].cultureText=getCultureLabel(lastData.culture)
                    alluser[emailKey].culture_Original=lastData.culture
                  }

                                
                  const time_peding=company.performance_review&&company.performance_review.pending?company.performance_review.pending:1
                  const time_overdue=company.performance_review&&company.performance_review.overdue?company.performance_review.overdue:2
                  if(moment(lastData.createdate).isAfter(moment(companyNow).add(-time_peding,'months'))){
                    reviewActivity.completed++
                    
                    
                    arrData[lastData.culture][lastData.goal]++
                    if(company.reset_completed_monthly==true){
                      if(moment(lastData.createdate).isAfter(moment(companyNow).startOf('month'))){
                        alluser[emailKey].reviews_status='Completed'
                      }else{
                        alluser[emailKey].reviews_status='Pending'
                      }
                    }else{
                      alluser[emailKey].reviews_status='Completed'
                   }
                    

                    alluser[emailKey].goal_Original=lastData.goal
                    alluser[emailKey].goal=lastData.goal==4||lastData.goal==3?100:lastData.goal==2?50:0

                    alluser[emailKey].culture_Original=lastData.culture
                    alluser[emailKey].culture=lastData.culture==4||lastData.culture==3?100:lastData.culture==2?50:0


                    if(lastData.goal&&lastData.culture){
                      if((lastData.culture==3||lastData.culture==4)&&(lastData.goal==3||lastData.goal==4)){
                        alluser[emailKey].both=100
                      }else{
                        alluser[emailKey].both=0
                      }
                    }  


                  }else if(moment(lastData.createdate).isAfter(moment(companyNow).add(-time_overdue,'months'))){
                      reviewActivity.pending++
                      //console.log('lastData',lastData.culture,lastData.goal)
                      
                      arrData[lastData.culture][lastData.goal]++
                      
                      alluser[emailKey].reviews_status='Pending'

                      alluser[emailKey].goal_Original=lastData.goal
                      alluser[emailKey].goal=lastData.goal==4||lastData.goal==3?100:lastData.goal==2?50:0

                      alluser[emailKey].culture_Original=lastData.culture
                      alluser[emailKey].culture=lastData.culture==4||lastData.culture==3?100:lastData.culture==2?50:0

                      if(lastData.goal&&lastData.culture){
                        if((lastData.culture==3||lastData.culture==4)&&(lastData.goal==3||lastData.goal==4)){
                          alluser[emailKey].both=100
                        }else{
                          alluser[emailKey].both=0
                        }
                      }  

                  }else{
                      reviewActivity.overdue++
                      alluser[emailKey].reviews_status='Overdue'
                  }
                }else{
                  reviewActivity.overdue++
                  alluser[emailKey].reviews_status='Overdue'

                  alluser[emailKey].track=[]
                  alluser[emailKey].goalText=''
                  alluser[emailKey].cultureText=''
                  alluser[emailKey].both=0
                  alluser[emailKey].goal=0
                  alluser[emailKey].culture=0

                  for(let i=5;i>=0;i--){
                    let track={month:'',track:'',text:'',text1:'',goal_value:'',culture_value:'',goal_ratings:[] as any[],status_filter:false}
                    const month=format(addMonths(companyNow,-i), 'YYYY-MM')
                    const findData= _.find(newData, function(o) {
                      return format(new Date(o.createdate), 'YYYY-MM')==month
                    })
                    track.month=format(addMonths(companyNow,-i), 'MMMM YYYY')
                    if(findData){

                      track.text=getGoalTextPrefix(findData.goal)+': '+findData.goal_value
                      track.goal_value=getGoalLabel(findData.goal)
                      track.goal_ratings=findData.goal_ratings || []

                      track.text1=getCultureTextPrefix(findData.culture)+': '+findData.culture_value
                      track.culture_value=getCultureLabel(findData.culture)


                      if((findData.culture==3||findData.culture==4)&&(findData.goal==3||findData.goal==4)){
                        track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_pink_gem_28.png?alt=media&token=fcbe2996-f5b9-4eec-8b4b-aceed3f39a74')
                      
                      }else{
                        track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_gray_gem_28.png?alt=media&token=a37d9466-4c58-410e-8b60-bddeaae43dc0')
                      
                      }
                    }else{
                      track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                      track.text='No performance boost provided this month'
                    }
                    alluser[emailKey].track.push(track)
                  }


                }
              }else{
                const time_peding=company.performance_review&&company.performance_review.pending?company.performance_review.pending:1
                const time_overdue=company.performance_review&&company.performance_review.overdue?company.performance_review.overdue:2
                if(moment(alluser[emailKey].createdatetime).isAfter(moment(companyNow).add(-time_overdue,'months'))){
                  reviewActivity.pending++
                  alluser[emailKey].reviews_status='Pending'
                }else{
                  reviewActivity.overdue++
                  alluser[emailKey].reviews_status='Overdue'
                }
                alluser[emailKey].track=[]
                  for(let i=5;i>=0;i--){
                    let track={month:'',track:'',text:'',text1:'',goal_value:'',culture_value:'',goal_ratings:[] as any[],status_filter:false}
                    track.month=format(addMonths(companyNow,-i), 'MMMM YYYY')
                    track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                    track.text='No performance boost provided this month'
                    alluser[emailKey].track.push(track)
                }
              }
            }

            let tableData:Array<any>=[]
            let family:Array<any> =[]
            let cultuerAdd:number=0
            let reviewCompleted:number=0
            let GoalsProgress:number=0
            let both:number=0
            let boss = _.groupBy(alluser, function (b) {
              return b.boss;
            });
            for(const key in boss){
              family=[]
              GoalsProgress=0
              cultuerAdd=0
              both=0
              reviewCompleted=0
              if(key!='undefined'){
                for(const key2 in boss[key]){                
                  boss[key][key2].team_name= team[boss[key][key2].team]&&team[boss[key][key2].team].name?team[boss[key][key2].team].name:'',
                  GoalsProgress+=boss[key][key2].goal?boss[key][key2].goal:0
                  boss[key][key2].goal_Original=boss[key][key2].goal_Original?boss[key][key2].goal_Original:0
                  boss[key][key2].culture_Original=boss[key][key2].culture_Original?boss[key][key2].culture_Original:0
                  cultuerAdd+=boss[key][key2].culture?boss[key][key2].culture:0
                  reviewCompleted+=boss[key][key2].reviews_status=='Completed'?100:0
                  reviewCompleted+=boss[key][key2].reviews_status=='Pending'?100:0
                  both+=boss[key][key2].both?boss[key][key2].both:0
                  let user_email=boss[key][key2].email
                  const ciphertext = CryptoJS.AES.encrypt(user_email, 'performance-summary-report').toString();
                  const url = 'https://insights.happily.ai/performance-summary-report/'+encodeURIComponent(ciphertext);
                  boss[key][key2].link=url
                  
                  family.push(boss[key][key2])
                }
                const emailKey=key.replace(/\./g, "||")
                // console.log('alluser[emailKey]s',alluser[emailKey])
                if(alluser[emailKey]){
                  tableData.push({
                    
                    profilepic_crop:alluser[emailKey].profilepic_crop?alluser[emailKey].profilepic_crop:'',
                    firstname: alluser[emailKey].firstname? alluser[emailKey].firstname:'',
                    lastname:  alluser[emailKey].lastname? alluser[emailKey].lastname:'',
                    team_name: team[ alluser[emailKey].team]?team[ alluser[emailKey].team].name:'',
                    email:  alluser[emailKey].email? alluser[emailKey].email:'',
                    reviewCompleted:(reviewCompleted/boss[key].length).toFixed(),
                    GoalsProgress:(GoalsProgress/boss[key].length).toFixed(),
                    cultuerAdd:(cultuerAdd/boss[key].length).toFixed(),
                    both:(both/boss[key].length).toFixed(),
                    family:family
                  })
                }
                
              }
            
            }

            const avg={cultuerAdd:{value:0,total:0},GoalsProgress:{value:0,total:0},Both:{value:0,total:0}}
            let calavg={cultuerAdd:'',GoalsProgress:'',Both:''}
    
            const today={
              cultuerAdd:todayData.cultuerAdd?todayData.cultuerAdd.value/todayData.cultuerAdd.total:0,
              GoalsProgress:todayData.GoalsProgress?todayData.GoalsProgress.value/todayData.GoalsProgress.total:0,
              Both:todayData.GoalsProgress?todayData.Both.value/todayData.Both.total:0
            }
            for(let i=6;i>=0;i--){
              const month=format(addMonths(companyNow,-i), 'YYYY-MM')
              avg.cultuerAdd.value+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value:0
              avg.cultuerAdd.total+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].total:0
              avg.GoalsProgress.value+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value:0
              avg.GoalsProgress.total+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].total:0
              avg.Both.value+=dataChart.Both[month]?dataChart.Both[month].value:0
              avg.Both.total+=dataChart.Both[month]?dataChart.Both[month].total:0
              if(i!=0){
                lineChart.cultuerAdd.push(dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value/dataChart.cultuerAdd[month].total:0)
                lineChart.GoalsProgress.push(dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value/dataChart.GoalsProgress[month].total:0)
                lineChart.Both.push(dataChart.Both[month]?dataChart.Both[month].value/dataChart.Both[month].total:0)
              }
              
              if(i==0){
                lineChart.cultuerAdd.push(isNaN(today.cultuerAdd)?0:today.cultuerAdd)
                lineChart.GoalsProgress.push(isNaN(today.GoalsProgress)?0:today.GoalsProgress)
                lineChart.Both.push(isNaN(today.Both)?0:today.Both)
                calavg.cultuerAdd=isNaN(avg.cultuerAdd.value/avg.cultuerAdd.total)?'0':(avg.cultuerAdd.value/avg.cultuerAdd.total).toFixed()
                calavg.GoalsProgress=isNaN(avg.GoalsProgress.value/avg.GoalsProgress.total)?'0':(avg.GoalsProgress.value/avg.GoalsProgress.total).toFixed()
                calavg.Both=isNaN(avg.Both.value/avg.Both.total)?'0':(avg.Both.value/avg.Both.total).toFixed()
              }

            }
            for(const key in arrData){
              for(const key2 in arrData[key]){
                if(arrData[key][key2]>= arrData.mex){
                  arrData.mex=arrData[key][key2]
                }
              }
            }

            tableData=_.orderBy(tableData, 
              [
                  (item) => parseInt(item.reviewCompleted),
                  (item) => parseInt(item.GoalsProgress)
              ], 
              ['desc', 'desc']
          )
            
            //tableData=_.orderBy(tableData, function(dateObj) {return dateObj.firstname},['asc'])
            
            state.reviewActivityOri=reviewActivity
            state.tableDataOri=tableData
            state.ChartGoalandCutureOri=arrData
            state.lineChartOri=lineChart
            state.avgOri=calavg

        
            
            //commit('setreviewActivity',reviewActivity)
            //commit('setdatachart',lineChart)
            //commit('setavg',calavg)
            //commit('setChartGoalandCuture',arrData)
            //commit('settableData',tableData)
            //commit('setdataAll',dataAll)
            commit('settableDataAll',tableData)
            commit('setloading', false)
            if(rootState.authen.user.user_type == 'leadership'){
              state.statusTeam=true
              state.valueTeam=rootState.authen.user.team
            }
            if(state.statusTeam==true){
              dispatch('changeTeam',state.valueTeam)
            }else{
              commit('setreviewActivity',reviewActivity)
              commit('setdatachart',lineChart)
              commit('setavg',calavg)
              commit('setChartGoalandCuture',arrData)
              commit('settableData',tableData)
              commit('setdataAll',dataAll)
              commit('settableDataAll',tableData)
              commit('setloading', false)

            }
            
      


          })
        }
      },

      async changeTime({dispatch,commit,rootState,state}:any, value:any){
        //console.log('changeTime',value)
        commit('setperiod',{key:value.key,startdate:value.startdate,enddate:value.enddate})
        const timezone = await getCompanyTimezone(rootState.authen.user.company)
        const companyNow = toCompanyDate(new Date(), timezone)
        const reviewActivity={completed:0,pending:0,overdue:0,total:0}
        const data_all_Period=_.cloneDeep(state.data_all_Period)
        const arrData:any={4:{1:0,2:0,3:0,4:0,},
        3:{1:0,2:0,3:0,4:0,},
        2:{1:0,2:0,3:0,4:0,},
        1:{1:0,2:0,3:0,4:0,},
        mex:0}
        const team=rootState.main.allTeam
        let todayData:any={cultuerAdd:{value:0,total:0},GoalsProgress:{value:0,total:0},Both:{value:0,total:0}}
        const company = await getCompany(rootState.authen.user.company)
        let lineChart:any = {cultuerAdd:[],GoalsProgress:[],Both:[],avg:{cultuerAdd:0,GoalsProgress:0,Both:0}}
        let dataChart={cultuerAdd:{},GoalsProgress:{},Both:{}}
        const alluser=_.cloneDeep(rootState.main.allUser)
        let data:any=[]
        let mount_review=5
        const end_date=state.period.enddate
        const start_date=state.period.startdate
        if(state.period.key==='lastYear'){
            mount_review=11   
        }else if(format(new Date(start_date), 'YYYY-MM')==format(new Date(end_date), 'YYYY-MM')){
          mount_review=0
        }else if(state.period.key==='yearToDate'){
          let count=0
          while(format(addMonths(new Date(start_date),count), 'YYYY-MM')!=format(new Date(end_date), 'YYYY-MM')){
            count++
          }
         // console.log('count',count)
          mount_review=count
        }else {
          mount_review=6
        }

        
        //if(value.key=='Past 6 Months'||value.key=='currentMonth'||value.key=='last3months'||value.key=='lastMonth'||value.key=='yearToDate'){
          const past6month=format(addMonths(companyNow,-6), 'YYYY-MM-01')
         //console.log('past6month',past6month)
          if(value.startdate>past6month){
            //console.log('1')
            data=state.dataAll
          }else if(data_all_Period[value.key]){
            //console.log('2')
            data=data_all_Period[value.key]
          }else{
            //console.log('3')
            dispatch('getSendReviewGem',rootState.authen.user)
            return
          }


     


          if(format(new Date(state.period.startdate), 'YYYY-MM-DD')<=format(new Date(past6month), 'YYYY-MM-DD')){

                        //console.log('dataChart',dataChart)
                        for(const key in data){
                          //console.log('data[key]',data[key])
                          if(data[key]){
                          const month=format(new Date(data[key].createdate), 'YYYY-MM')
                          if(data[key].culture){
                            if(!dataChart.cultuerAdd[month]){
                              dataChart.cultuerAdd[month]={value:0,total:0}
                            }
                            dataChart.cultuerAdd[month].total++
                            dataChart.cultuerAdd[month].value+=data[key].culture==4||data[key].culture==3?100:data[key].culture==2?50:0
                          }
                          if(data[key].goal){
                            if(!dataChart.GoalsProgress[month]){
                              dataChart.GoalsProgress[month]={value:0,total:0}
                            }
                            dataChart.GoalsProgress[month].total++
                            dataChart.GoalsProgress[month].value+=data[key].goal==4||data[key].goal==3?100:data[key].goal==2?50:0
                            
                          }
                          if(data[key].goal&&data[key].culture){
                            if(!dataChart.Both[month]){
                              dataChart.Both[month]={value:0,total:0}
                            }
                            dataChart.Both[month].total++
                            if((data[key].culture==3||data[key].culture==4)&&(data[key].goal==3||data[key].goal==4)){
                              dataChart.Both[month].value+=100
                            }else{
                              dataChart.Both[month].value+=0
                            }
                            //arrData[data.culture][data.goal]++
                          }


                       
                          }
                        }

                       // console.log('dataChart',dataChart)

                        const  receiver = _.groupBy(data, function (b) {
                          return b.receiver;
                        });
                        
                       
                        for(const emailKey in alluser){
                          reviewActivity.total++
                          if(receiver[alluser[emailKey].email]){
                            const newData =_.orderBy(receiver[alluser[emailKey].email], function(dateObj) {
                              return new Date(dateObj.createdate);
                            },['desc'])
                          
                            if(newData){
                            
                              const lastData = newData[0]
                              alluser[emailKey].track=[]
                              alluser[emailKey].date_review=lastData.createdate
            
                              
            
                              //track
                              for(let i=mount_review;i>=0;i--){
                                //console.log('track',end_date)
                                let track={month:'',track:'',text:'',text1:'',review_id:'',goal_value:'',culture_value:'',goal_ratings:[] as any[],status_filter:false}
                                
                                const month=format(addMonths(new Date(end_date),-i), 'YYYY-MM')
                                //console.log('track',month)
                                //console.log('====month=====',month)
                                const findData= _.find(newData, function(o) {
                                  return format(new Date(o.createdate), 'YYYY-MM')==month
                                })
                                track.month=format(addMonths(new Date(end_date),-i), 'MMMM YYYY')
                                if(findData){
                                  track.review_id=findData.review_id
                                  track.text=getGoalTextPrefix(findData.goal)+': '+findData.goal_value
                                  track.goal_value=getGoalLabel(findData.goal)
                                  track.goal_ratings=findData.goal_ratings || []

                                  track.text1=getCultureTextPrefix(findData.culture)+': '+findData.culture_value
                                  track.culture_value=getCultureLabel(findData.culture)

                                  if((findData.culture==3||findData.culture==4)&&(findData.goal==3||findData.goal==4)){
                                    track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_pink_gem_28.png?alt=media&token=fcbe2996-f5b9-4eec-8b4b-aceed3f39a74')

                                  }else{
                                    track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_gray_gem_28.png?alt=media&token=a37d9466-4c58-410e-8b60-bddeaae43dc0')

                                  }
                                }else{
                                  track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                                  track.text='No performance boost provided this month'
                                }
                                //console.log('track',track)
                                alluser[emailKey].track.push(track)
                              }
            
                              
                              if(lastData.goal){
                                alluser[emailKey].goalText=getGoalLabel(lastData.goal)
                                alluser[emailKey].goal_Original=lastData.goal
                              }
                              if(lastData.culture){
                                alluser[emailKey].cultureText=getCultureLabel(lastData.culture)
                                alluser[emailKey].culture_Original=lastData.culture
                              }
                              
                                alluser[emailKey].reviews_status='-'
                                arrData[lastData.culture][lastData.goal]++
                                alluser[emailKey].goal_Original=lastData.goal
                                alluser[emailKey].goal=lastData.goal==4||lastData.goal==3?100:lastData.goal==2?50:0
              
                                alluser[emailKey].culture_Original=lastData.culture
                                alluser[emailKey].culture=lastData.culture==4||lastData.culture==3?100:lastData.culture==2?50:0
              
              
                                  if(lastData.goal&&lastData.culture){
                                    if((lastData.culture==3||lastData.culture==4)&&(lastData.goal==3||lastData.goal==4)){
                                      alluser[emailKey].both=100
                                    }else{
                                      alluser[emailKey].both=0
                                    }
                                  }  
                            }
                            
                            
                            else{
                             
                              
                              alluser[emailKey].reviews_status='-'
                              alluser[emailKey].track=[]
                              alluser[emailKey].goalText=''
                              alluser[emailKey].cultureText=''
                              alluser[emailKey].both=0
                              alluser[emailKey].goal=0
                              alluser[emailKey].culture=0
            
                              for(let i=mount_review;i>=0;i--){
                                let track={month:'',track:'',text:'',text1:'',goal_value:'',culture_value:'',goal_ratings:[] as any[],status_filter:false}
                                const month=format(addMonths(new Date(end_date),-i), 'YYYY-MM')
                                const findData= _.find(newData, function(o) {
                                  return format(new Date(o.createdate), 'YYYY-MM')==month
                                })
                                track.month=format(addMonths(new Date(end_date),-i), 'MMMM YYYY')
                                if(findData){
            
                                  track.text=getGoalTextPrefix(findData.goal)+': '+findData.goal_value
                                  track.goal_value=getGoalLabel(findData.goal)
                                  track.goal_ratings=findData.goal_ratings || []

                                  track.text1=getCultureTextPrefix(findData.culture)+': '+findData.culture_value
                                  track.culture_value=getCultureLabel(findData.culture)

                                  if((findData.culture==3||findData.culture==4)&&(findData.goal==3||findData.goal==4)){
                                    track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_pink_gem_28.png?alt=media&token=fcbe2996-f5b9-4eec-8b4b-aceed3f39a74')
                                  
                                  }else{
                                    track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_gray_gem_28.png?alt=media&token=a37d9466-4c58-410e-8b60-bddeaae43dc0')
                                  
                                  }
                                }else{
                                  track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                                  track.text='No performance boost provided this month'
                                }
                                alluser[emailKey].track.push(track)
                              }
            
            
                            }
                          }
                          
                          
                          else{
                            const time_peding=company.performance_review&&company.performance_review.pending?company.performance_review.pending:1
                            const time_overdue=company.performance_review&&company.performance_review.overdue?company.performance_review.overdue:2
                            alluser[emailKey].reviews_status='-'
                           
                            alluser[emailKey].track=[]
                              for(let i=mount_review;i>=0;i--){
                                let track={month:'',track:'',text:'',text1:'',goal_value:'',culture_value:'',goal_ratings:[] as any[],status_filter:false}
                                track.month=format(addMonths(new Date(end_date),-i), 'MMMM YYYY')
                                track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                                track.text='No performance boost provided this month'
                                alluser[emailKey].track.push(track)
                            }
                          }
                        }
            
                        let tableData:Array<any>=[]
                        let family:Array<any> =[]
                        let cultuerAdd:number=0
                        let reviewCompleted:number=0
                        let GoalsProgress:number=0
                        let both:number=0
                        let boss = _.groupBy(alluser, function (b) {
                          return b.boss;
                        });
                        for(const key in boss){
                          family=[]
                          GoalsProgress=0
                          cultuerAdd=0
                          both=0
                          reviewCompleted=0
                          if(key!='undefined'){
                            for(const key2 in boss[key]){                
                              boss[key][key2].team_name= team[boss[key][key2].team]&&team[boss[key][key2].team].name?team[boss[key][key2].team].name:'',
                              GoalsProgress+=boss[key][key2].goal?boss[key][key2].goal:0
                              boss[key][key2].goal_Original=boss[key][key2].goal_Original?boss[key][key2].goal_Original:0
                              boss[key][key2].culture_Original=boss[key][key2].culture_Original?boss[key][key2].culture_Original:0
                              cultuerAdd+=boss[key][key2].culture?boss[key][key2].culture:0
                              reviewCompleted+=boss[key][key2].reviews_status=='Completed'?100:0
                              reviewCompleted+=boss[key][key2].reviews_status=='Pending'?100:0
                              both+=boss[key][key2].both?boss[key][key2].both:0
                              let user_email=boss[key][key2].email
                              const ciphertext = CryptoJS.AES.encrypt(user_email, 'performance-summary-report').toString();
                              const url = 'https://insights.happily.ai/performance-summary-report/'+encodeURIComponent(ciphertext);
                              boss[key][key2].link=url
                              
                              family.push(boss[key][key2])
                            }
                            const emailKey=key.replace(/\./g, "||")
                            if(alluser[emailKey]){
                              tableData.push({
                                
                                profilepic_crop:alluser[emailKey].profilepic_crop?alluser[emailKey].profilepic_crop:'',
                                firstname: alluser[emailKey].firstname? alluser[emailKey].firstname:'',
                                lastname:  alluser[emailKey].lastname? alluser[emailKey].lastname:'',
                                team_name: team[ alluser[emailKey].team]?team[ alluser[emailKey].team].name:'',
                                email:  alluser[emailKey].email? alluser[emailKey].email:'',
                                reviewCompleted:(reviewCompleted/boss[key].length).toFixed(),
                                GoalsProgress:(GoalsProgress/boss[key].length).toFixed(),
                                cultuerAdd:(cultuerAdd/boss[key].length).toFixed(),
                                both:(both/boss[key].length).toFixed(),
                                family:family
                              })
                            }
                            
                          }
                        
                        }
            
                        const avg={cultuerAdd:{value:0,total:0},GoalsProgress:{value:0,total:0},Both:{value:0,total:0}}
                        let calavg={cultuerAdd:'',GoalsProgress:'',Both:''}
                
                        const today={
                          cultuerAdd:todayData.cultuerAdd?todayData.cultuerAdd.value/todayData.cultuerAdd.total:0,
                          GoalsProgress:todayData.GoalsProgress?todayData.GoalsProgress.value/todayData.GoalsProgress.total:0,
                          Both:todayData.GoalsProgress?todayData.Both.value/todayData.Both.total:0
                        }
            
                        //console.log('dataChart',dataChart)
            
                        for(let i=mount_review;i>=0;i--){
                          const month=format(addMonths(new Date(end_date),-i), 'YYYY-MM')
                          avg.cultuerAdd.value+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value:0
                          avg.cultuerAdd.total+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].total:0
                          avg.GoalsProgress.value+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value:0
                          avg.GoalsProgress.total+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].total:0
                          avg.Both.value+=dataChart.Both[month]?dataChart.Both[month].value:0
                          avg.Both.total+=dataChart.Both[month]?dataChart.Both[month].total:0
                        
                            lineChart.cultuerAdd.push(dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value/dataChart.cultuerAdd[month].total:0)
                            lineChart.GoalsProgress.push(dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value/dataChart.GoalsProgress[month].total:0)
                            lineChart.Both.push(dataChart.Both[month]?dataChart.Both[month].value/dataChart.Both[month].total:0)
                          
                          
                          if(i==0){
                            
                            calavg.cultuerAdd=isNaN(avg.cultuerAdd.value/avg.cultuerAdd.total)?'0':(avg.cultuerAdd.value/avg.cultuerAdd.total).toFixed()
                            calavg.GoalsProgress=isNaN(avg.GoalsProgress.value/avg.GoalsProgress.total)?'0':(avg.GoalsProgress.value/avg.GoalsProgress.total).toFixed()
                            calavg.Both=isNaN(avg.Both.value/avg.Both.total)?'0':(avg.Both.value/avg.Both.total).toFixed()
                          }
            
                        }
                        for(const key in arrData){
                          for(const key2 in arrData[key]){
                            if(arrData[key][key2]>= arrData.mex){
                              arrData.mex=arrData[key][key2]
                            }
                          }
                        }
            
                        tableData=_.orderBy(tableData, 
                          [
                              (item) => parseInt(item.reviewCompleted),
                              (item) => parseInt(item.GoalsProgress)
                          ], 
                          ['desc', 'desc']
                      )
                        //tableData=_.orderBy(tableData, function(dateObj) {return dateObj.firstname},['asc'])
                        //console.log('calavg',calavg)
                        state.reviewActivityOri=reviewActivity
                        state.tableDataOri=tableData
                        state.ChartGoalandCutureOri=arrData
                        state.lineChartOri=lineChart
                        state.avgOri=calavg
                     
                      
                        commit('settableDataAll',tableData)
                        if(state.statusTeam==true){
                          dispatch('changeTeam',state.valueTeam)
                        }else{
                          commit('setreviewActivity',reviewActivity)
                          commit('setdatachart',lineChart)
                          commit('setavg',calavg)
                          commit('setChartGoalandCuture',arrData)
                          commit('settableData',tableData)
                          commit('settableDataAll',tableData)
                          commit('setloading', false)
                        }
                   
  
  
          }else{
            //console.log('data----')
            const filterData=_.filter(data, function (b) {
              return format(new Date(b.createdate), 'YYYY-MM-DD')>=format(new Date(value.startdate), 'YYYY-MM-DD')&&format(new Date(b.createdate), 'YYYY-MM-DD')<=format(new Date(value.enddate), 'YYYY-MM-DD')
            });
            //console.log('filterData',filterData)
            for(const key in filterData){
              const data=filterData[key]
              const month=format(new Date(data.createdate), 'YYYY-MM')



              if(format(new Date(data.createdate), 'YYYY-MM-DD')>=format(addDays(companyNow,-30), 'YYYY-MM-DD')){
                if(data.culture){
                
                  todayData.cultuerAdd.total++
                  todayData.cultuerAdd.value+=data.culture==4||data.culture==3?100:data.culture==2?50:0
                }
                if(data.goal){
                  
                  todayData.GoalsProgress.total++
                  todayData.GoalsProgress.value+=data.goal==4||data.goal==3?100:data.goal==2?50:0
                  
                }
                if(data.goal&&data.culture){
                  
                  todayData.Both.total++
                  if((data.culture==3||data.culture==4)&&(data.goal==3||data.goal==4)){
                    todayData.Both.value+=100
                  }else{
                    todayData.Both.value+=0
                  }
              
                }
              }


              if(data.culture){
                if(!dataChart.cultuerAdd[month]){
                  dataChart.cultuerAdd[month]={value:0,total:0}
                }
                dataChart.cultuerAdd[month].total++
                dataChart.cultuerAdd[month].value+=data.culture==4||data.culture==3?100:data.culture==2?50:0
              }
              if(data.goal){
                if(!dataChart.GoalsProgress[month]){
                  dataChart.GoalsProgress[month]={value:0,total:0}
                }
                dataChart.GoalsProgress[month].total++
                dataChart.GoalsProgress[month].value+=data.goal==4||data.goal==3?100:data.goal==2?50:0
                
              }
              if(data.goal&&data.culture){
                if(!dataChart.Both[month]){
                  dataChart.Both[month]={value:0,total:0}
                }
                dataChart.Both[month].total++
                if((data.culture==3||data.culture==4)&&(data.goal==3||data.goal==4)){
                  dataChart.Both[month].value+=100
                }else{
                  dataChart.Both[month].value+=0
                }
                //arrData[data.culture][data.goal]++
              }

              
            }


            const  receiver = _.groupBy(filterData, function (b) {
              return b.receiver;
            });
            
            for(const emailKey in alluser){
              reviewActivity.total++
              if(receiver[alluser[emailKey].email]){
                const newData =_.orderBy(receiver[alluser[emailKey].email], function(dateObj) {
                  return new Date(dateObj.createdate);
                },['desc'])
              
                if(newData){
                
                  const lastData = newData[0]
                  alluser[emailKey].track=[]
                  alluser[emailKey].date_review=lastData.createdate
  
                  //track
                  for(let i=5;i>=0;i--){
                    let track={month:'',track:'',text:'',text1:'',review_id:'',goal_value:'',culture_value:'',goal_ratings:[] as any[],status_filter:false}
                    
                    const month=format(addMonths(companyNow,-i), 'YYYY-MM')
                    //('month',month)
                    const findData= _.find(newData, function(o) {
                      return format(new Date(o.createdate), 'YYYY-MM')==month
                    })
                    track.month=format(addMonths(companyNow,-i), 'MMMM YYYY')
                    if(findData){
                      track.review_id=findData.review_id
                      track.text=getGoalTextPrefix(findData.goal)+': '+findData.goal_value
                      track.goal_value=getGoalLabel(findData.goal)
                      track.goal_ratings=findData.goal_ratings || []

                      track.text1=getCultureTextPrefix(findData.culture)+': '+findData.culture_value
                      track.culture_value=getCultureLabel(findData.culture)
  
                      if((findData.culture==3||findData.culture==4)&&(findData.goal==3||findData.goal==4)){
                        track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_pink_gem_28.png?alt=media&token=fcbe2996-f5b9-4eec-8b4b-aceed3f39a74')
                      
                      }else{
                        track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_gray_gem_28.png?alt=media&token=a37d9466-4c58-410e-8b60-bddeaae43dc0')
                      
                      }
                    }else{
                      track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                      track.text='No performance boost provided this month'
                      if(format(new Date(value.startdate), 'YYYY-MM')==format(new Date(value.enddate), 'YYYY-MM')){
                        if(month!=format(new Date(value.startdate), 'YYYY-MM')){
                          track.status_filter=true
                        }

                      }else if(format(new Date(value.startdate), 'YYYY-MM')>month&&month<format(new Date(value.enddate), 'YYYY-MM')){
                       
                        track.status_filter=true
                      }
                    }
                    //console.log('track',track)
                    alluser[emailKey].track.push(track)
                  }
  
  
                  if(lastData.goal){
                    alluser[emailKey].goalText=getGoalLabel(lastData.goal)
                    alluser[emailKey].goal_Original=lastData.goal
                  }
                  if(lastData.culture){
                    alluser[emailKey].cultureText=getCultureLabel(lastData.culture)
                    alluser[emailKey].culture_Original=lastData.culture
                  }
  
                                
                  const time_peding=company.performance_review&&company.performance_review.pending?company.performance_review.pending:1
                  const time_overdue=company.performance_review&&company.performance_review.overdue?company.performance_review.overdue:2

                  if(moment(lastData.createdate).isAfter(moment(companyNow).add(-time_peding,'months'))){
                    if(state.period.key==='last3months'||state.period.key==='last6months'||state.period.key==='yearToDate'){
                      reviewActivity.completed++
                      alluser[emailKey].reviews_status='Completed'
                    }else{

                      alluser[emailKey].reviews_status='-'
                    }

                    
                    
                    
                    arrData[lastData.culture][lastData.goal]++
                    
  
                    alluser[emailKey].goal_Original=lastData.goal
                    alluser[emailKey].goal=lastData.goal==4||lastData.goal==3?100:lastData.goal==2?50:0
  
                    alluser[emailKey].culture_Original=lastData.culture
                    alluser[emailKey].culture=lastData.culture==4||lastData.culture==3?100:lastData.culture==2?50:0
  
  
                    if(lastData.goal&&lastData.culture){
                      if((lastData.culture==3||lastData.culture==4)&&(lastData.goal==3||lastData.goal==4)){
                        alluser[emailKey].both=100
                      }else{
                        alluser[emailKey].both=0
                      }
                    }  
  
  
                  }else if(moment(lastData.createdate).isAfter(moment(companyNow).add(-time_overdue,'months'))){
                      if(state.period.key==='last3months'||state.period.key==='last6months'||state.period.key==='yearToDate'){
                        reviewActivity.pending++
                        alluser[emailKey].reviews_status='Pending'
                      }else{
                      
                        alluser[emailKey].reviews_status='-'
                      }
                      
                      //console.log('lastData',lastData.culture,lastData.goal)
                      
                      arrData[lastData.culture][lastData.goal]++
                      
                      
  
                      alluser[emailKey].goal_Original=lastData.goal
                      alluser[emailKey].goal=lastData.goal==4||lastData.goal==3?100:lastData.goal==2?50:0
  
                      alluser[emailKey].culture_Original=lastData.culture
                      alluser[emailKey].culture=lastData.culture==4||lastData.culture==3?100:lastData.culture==2?50:0
  
                      if(lastData.goal&&lastData.culture){
                        if((lastData.culture==3||lastData.culture==4)&&(lastData.goal==3||lastData.goal==4)){
                          alluser[emailKey].both=100
                        }else{
                          alluser[emailKey].both=0
                        }
                      }  
  
                  }else{
                    if(state.period.key==='last3months'||state.period.key==='last6months'||state.period.key==='yearToDate'){
                      reviewActivity.overdue++
                      alluser[emailKey].reviews_status='Overdue'
                    }else{
                      alluser[emailKey].reviews_status='-'
                    }



                    if(state.period.key!=='lastMonth'&&state.period.key!='currentMonth'&&format(new Date(value.enddate), 'YYYY-MM')==format(new Date(value.startdate), 'YYYY-MM')){
                    
                      arrData[lastData.culture][lastData.goal]++
                      
    
                      alluser[emailKey].goal_Original=lastData.goal
                      alluser[emailKey].goal=lastData.goal==4||lastData.goal==3?100:lastData.goal==2?50:0
    
                      alluser[emailKey].culture_Original=lastData.culture
                      alluser[emailKey].culture=lastData.culture==4||lastData.culture==3?100:lastData.culture==2?50:0
    
    
                      if(lastData.goal&&lastData.culture){
                        if((lastData.culture==3||lastData.culture==4)&&(lastData.goal==3||lastData.goal==4)){
                          alluser[emailKey].both=100
                        }else{
                          alluser[emailKey].both=0
                        }
                      }  
                    }
                    
                      
                  }
                }else{
                  
                  if(state.period.key==='last3months'||state.period.key==='last6months'||state.period.key==='yearToDate'){
                    reviewActivity.overdue++
                    alluser[emailKey].reviews_status='Overdue'
                  }else{
                    alluser[emailKey].reviews_status='-'
                  }
  
                  alluser[emailKey].track=[]
                  alluser[emailKey].goalText=''
                  alluser[emailKey].cultureText=''
                  alluser[emailKey].both=0
                  alluser[emailKey].goal=0
                  alluser[emailKey].culture=0
  
                  for(let i=5;i>=0;i--){
                    let track={month:'',track:'',text:'',text1:'',goal_value:'',culture_value:'',goal_ratings:[] as any[],status_filter:false}
                    const month=format(addMonths(companyNow,-i), 'YYYY-MM')
                    const findData= _.find(newData, function(o) {
                      return format(new Date(o.createdate), 'YYYY-MM')==month
                    })
                    track.month=format(addMonths(companyNow,-i), 'MMMM YYYY')
                    if(findData){
  
                      track.text=getGoalTextPrefix(findData.goal)+': '+findData.goal_value
                      track.goal_value=getGoalLabel(findData.goal)
                      track.goal_ratings=findData.goal_ratings || []

                      track.text1=getCultureTextPrefix(findData.culture)+': '+findData.culture_value
                      track.culture_value=getCultureLabel(findData.culture)
  
                      if((findData.culture==3||findData.culture==4)&&(findData.goal==3||findData.goal==4)){
                        track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_pink_gem_28.png?alt=media&token=fcbe2996-f5b9-4eec-8b4b-aceed3f39a74')
                      
                      }else{
                        track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_gray_gem_28.png?alt=media&token=a37d9466-4c58-410e-8b60-bddeaae43dc0')
                      
                      }
                    }else{
                      track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                      track.text='No performance boost provided this month'
                      if(format(new Date(value.startdate), 'YYYY-MM')==format(new Date(value.enddate), 'YYYY-MM')){
                        if(month!=format(new Date(value.startdate), 'YYYY-MM')){
                          track.status_filter=true
                        }

                      }else if(format(new Date(value.startdate), 'YYYY-MM')>month&&month<format(new Date(value.enddate), 'YYYY-MM')){
                      
                        track.status_filter=true
                      }
                      
                    }
                    alluser[emailKey].track.push(track)
                  }
  
  
                }
              }else{
                const time_peding=company.performance_review&&company.performance_review.pending?company.performance_review.pending:1
                const time_overdue=company.performance_review&&company.performance_review.overdue?company.performance_review.overdue:2
                if(moment(alluser[emailKey].createdatetime).isAfter(moment(companyNow).add(-time_overdue,'months'))){
                  if(state.period.key==='last3months'||state.period.key==='last6months'||state.period.key==='yearToDate'){
                    reviewActivity.pending++
                    alluser[emailKey].reviews_status='Pending'
                  }else{
                    alluser[emailKey].reviews_status='-'
                  }
                  
                }else{
                  if(state.period.key==='last3months'||state.period.key==='last6months'||state.period.key==='yearToDate'){
                    reviewActivity.overdue++
                    alluser[emailKey].reviews_status='Overdue'
                  }else{
                    alluser[emailKey].reviews_status='-'
                  }
                 
                }
                alluser[emailKey].track=[]
                  for(let i=5;i>=0;i--){
                    let track={month:'',track:'',text:'',text1:'',goal_value:'',culture_value:'',goal_ratings:[] as any[],status_filter:false}
                    track.month=format(addMonths(companyNow,-i), 'MMMM YYYY')
                    const month=format(addMonths(companyNow,-i), 'YYYY-MM')
                    track.track=('https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Femail%2Fsendgem%2Fsq_blank_gem_28.png?alt=media&token=b4394a16-e4ee-48af-901f-8fb662240c4f')
                    track.text='No performance boost provided this month'
                    
                    if(format(new Date(value.startdate), 'YYYY-MM')==format(new Date(value.enddate), 'YYYY-MM')){
                      if(month!=format(new Date(value.startdate), 'YYYY-MM')){
                        track.status_filter=true
                      }

                    }else if(format(new Date(value.startdate), 'YYYY-MM')>month&&month<format(new Date(value.enddate), 'YYYY-MM')){
                      
                      track.status_filter=true
                    }
                    alluser[emailKey].track.push(track)
                }
              }
            }
  
            let tableData:Array<any>=[]
            let family:Array<any> =[]
            let cultuerAdd:number=0
            let reviewCompleted:number=0
            let GoalsProgress:number=0
            let both:number=0
            let boss = _.groupBy(alluser, function (b) {
              return b.boss;
            });
            for(const key in boss){
              family=[]
              GoalsProgress=0
              cultuerAdd=0
              both=0
              reviewCompleted=0
              if(key!='undefined'){
                for(const key2 in boss[key]){                
                  boss[key][key2].team_name= team[boss[key][key2].team]&&team[boss[key][key2].team].name?team[boss[key][key2].team].name:'',
                  GoalsProgress+=boss[key][key2].goal?boss[key][key2].goal:0
                  boss[key][key2].goal_Original=boss[key][key2].goal_Original?boss[key][key2].goal_Original:0
                  boss[key][key2].culture_Original=boss[key][key2].culture_Original?boss[key][key2].culture_Original:0
                  cultuerAdd+=boss[key][key2].culture?boss[key][key2].culture:0
                  reviewCompleted+=boss[key][key2].reviews_status=='Completed'?100:0
                  reviewCompleted+=boss[key][key2].reviews_status=='Pending'?100:0
                  both+=boss[key][key2].both?boss[key][key2].both:0
                  let user_email=boss[key][key2].email
                  const ciphertext = CryptoJS.AES.encrypt(user_email, 'performance-summary-report').toString();
                  const url = 'https://insights.happily.ai/performance-summary-report/'+encodeURIComponent(ciphertext);
                  boss[key][key2].link=url
                  
                  family.push(boss[key][key2])
                }
                const emailKey=key.replace(/\./g, "||")
                // console.log('alluser[emailKey]s',alluser[emailKey])
                if(alluser[emailKey]){
                  tableData.push({
                    
                    profilepic_crop:alluser[emailKey].profilepic_crop?alluser[emailKey].profilepic_crop:'',
                    firstname: alluser[emailKey].firstname? alluser[emailKey].firstname:'',
                    lastname:  alluser[emailKey].lastname? alluser[emailKey].lastname:'',
                    team_name: team[ alluser[emailKey].team]?team[ alluser[emailKey].team].name:'',
                    email:  alluser[emailKey].email? alluser[emailKey].email:'',
                    reviewCompleted:(reviewCompleted/boss[key].length).toFixed(),
                    GoalsProgress:(GoalsProgress/boss[key].length).toFixed(),
                    cultuerAdd:(cultuerAdd/boss[key].length).toFixed(),
                    both:(both/boss[key].length).toFixed(),
                    family:family
                  })
                }
                
              }
            
            }
  
            const avg={cultuerAdd:{value:0,total:0},GoalsProgress:{value:0,total:0},Both:{value:0,total:0}}
            let calavg={cultuerAdd:'',GoalsProgress:'',Both:''}
    
            const today={
              cultuerAdd:todayData.cultuerAdd?todayData.cultuerAdd.value/todayData.cultuerAdd.total:0,
              GoalsProgress:todayData.GoalsProgress?todayData.GoalsProgress.value/todayData.GoalsProgress.total:0,
              Both:todayData.GoalsProgress?todayData.Both.value/todayData.Both.total:0
            }
           // console.log('today',today)
          //  console.log('dataChart',dataChart)
             
            for(let i=mount_review;i>=0;i--){
              const month=format(addMonths(new Date(end_date),-i), 'YYYY-MM')
              //console.log('month+id',month)
              avg.cultuerAdd.value+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value:0
              avg.cultuerAdd.total+=dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].total:0
              avg.GoalsProgress.value+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value:0
              avg.GoalsProgress.total+=dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].total:0
              avg.Both.value+=dataChart.Both[month]?dataChart.Both[month].value:0
              avg.Both.total+=dataChart.Both[month]?dataChart.Both[month].total:0
              if(i!=0){
                lineChart.cultuerAdd.push(dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value/dataChart.cultuerAdd[month].total:0)
                lineChart.GoalsProgress.push(dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value/dataChart.GoalsProgress[month].total:0)
                lineChart.Both.push(dataChart.Both[month]?dataChart.Both[month].value/dataChart.Both[month].total:0)
              }
              
              if(i==0){
                if(state.period.key!=='lastMonth'&&state.period.key!='currentMonth'&&format(new Date(value.enddate), 'YYYY-MM')==format(new Date(value.startdate), 'YYYY-MM')){
                  lineChart.cultuerAdd.push(dataChart.cultuerAdd[month]?dataChart.cultuerAdd[month].value/dataChart.cultuerAdd[month].total:0)
                  lineChart.GoalsProgress.push(dataChart.GoalsProgress[month]?dataChart.GoalsProgress[month].value/dataChart.GoalsProgress[month].total:0)
                  lineChart.Both.push(dataChart.Both[month]?dataChart.Both[month].value/dataChart.Both[month].total:0)
                }else{
                  lineChart.cultuerAdd.push(isNaN(today.cultuerAdd)?0:today.cultuerAdd)
                  lineChart.GoalsProgress.push(isNaN(today.GoalsProgress)?0:today.GoalsProgress)
                  lineChart.Both.push(isNaN(today.Both)?0:today.Both)
                }
                
                calavg.cultuerAdd=isNaN(avg.cultuerAdd.value/avg.cultuerAdd.total)?'0':(avg.cultuerAdd.value/avg.cultuerAdd.total).toFixed()
                calavg.GoalsProgress=isNaN(avg.GoalsProgress.value/avg.GoalsProgress.total)?'0':(avg.GoalsProgress.value/avg.GoalsProgress.total).toFixed()
                calavg.Both=isNaN(avg.Both.value/avg.Both.total)?'0':(avg.Both.value/avg.Both.total).toFixed()
                
              }
  
            }
            for(const key in arrData){
              for(const key2 in arrData[key]){
                if(arrData[key][key2]>= arrData.mex){
                  arrData.mex=arrData[key][key2]
                }
              }
            }
  
          tableData=_.orderBy(tableData, 
              [
                  (item) => parseInt(item.reviewCompleted),
                  (item) => parseInt(item.GoalsProgress)
              ], 
              ['desc', 'desc']
          )

            state.reviewActivityOri=reviewActivity
            state.tableDataOri=tableData
            state.ChartGoalandCutureOri=arrData
            state.lineChartOri=lineChart
            state.avgOri=calavg
            commit('settableDataAll',tableData)
            // console.log('tableData',tableData)
            // console.log('state.period.key',lineChart)
            // console.log('arrData',arrData)

            if(state.statusTeam==true){
            
              await dispatch('changeTeam',state.valueTeam)

              if(state.loading){
                commit('setloading', false)
              }

            }else{
       
              commit('setreviewActivity',reviewActivity)
              commit('setdatachart',lineChart)
              commit('setavg',calavg)
              commit('setChartGoalandCuture',arrData)
              commit('settableData',tableData)
              commit('settableDataAll',tableData)
              commit('setloading', false)
            }
            
          }




        
        


      },
      async sortbydata({dispatch,commit,rootState,state}:any, value:any){
        state.statussSort=true
        state.sortBy=value
        let tableData=state.tableData
        if(value=='Highest Completion Rate'){
        
          tableData=_.orderBy(tableData, function(dateObj) {return parseInt( dateObj.reviewCompleted)},['desc'])
        }else if(value=='Lowest Completion Rate'){
          
          tableData=_.orderBy(tableData, function(dateObj) {return parseInt(dateObj.reviewCompleted)},['asc'])
        }else if(value=='Highest Goal Progress'){
         
          tableData=_.orderBy(tableData, function(dateObj) {return parseInt(dateObj.GoalsProgress)},['desc'])
        }else if(value=='Lowest Gaol Progress'){
        
          tableData=_.orderBy(tableData, function(dateObj) {return parseInt(dateObj.GoalsProgress)},['asc'])
        }else if(value=='Highest Culture Add'){
     
          tableData=_.orderBy(tableData, function(dateObj) {return parseInt(dateObj.cultuerAdd)},['desc'])
        }else if(value=='Lowest Culture Add'){

          tableData=_.orderBy(tableData, function(dateObj) {return parseInt(dateObj.cultuerAdd)},['asc'])
        }else if(value=='Highest Both'){
  
          tableData=_.orderBy(tableData, function(dateObj) {return parseInt(dateObj.both)},['desc'])
        }else if(value=='Lowest Both'){

          tableData=_.orderBy(tableData, function(dateObj) {return parseInt(dateObj.both)},['asc'])
        }
        commit('settableData',tableData)
      },
      async searchData({dispatch,commit,rootState,state}:any, value:any){
        var re = new RegExp(value, 'gi')
        const tableData = state.statusTeam==true?state.tableData:(state.tableDataAll)
        const _tableData:Array<any> =[]

        let family:Array<any> =[]
        if (value) {
          for(const key in tableData){
            family=[]
            if (tableData[key].firstname.match(re)) {
              _tableData.push(tableData[key])
            } else if (tableData[key].lastname.match(re)) {
              _tableData.push(tableData[key])
            }else{
              for(const key1 in tableData[key].family){
                if (tableData[key].family[key1].firstname.match(re)) {
                  family.push(tableData[key].family[key1])
                } else if (tableData[key].family[key1].lastname.match(re)) {
                  family.push(tableData[key].family[key1]) 
                }
              }
              if(family.length>0){
                _tableData.push({...tableData[key],family:family})
              }
              

            }
            
            
          }
     

          // commit('setrewardsSearch', response)
          commit('settableData', _tableData)
        } else {
          if(state.statusTeam==true){
            dispatch('changeTeam',state.valueTeam)
          }else{
            commit('settableData', state.tableDataAll)
          }
          
        }
      },
    
      async download({dispatch,commit,rootState,state}:any, user:any){
        const timezone = await getCompanyTimezone(rootState.authen.user.company)
        const companyNow = toCompanyDate(new Date(), timezone)
        const past7month=format(addMonths(companyNow,-12), 'YYYY-MM')
        const dataAll:Array<any>=[]
        let _boss =  (await firebase.database().ref(`/boss/${ rootState.authen.user.company}`).once('value')).val()
        const reviewActivity={completed:0,pending:0,overdue:0,total:0}
        //const team=rootState.main.allTeam
        const alluser=_.cloneDeep(rootState.main.allUser)

        let family:Array<any>=[]
        let manager:Array<any>=[]
        const datatable=_.cloneDeep(state.tableData)
        

        for(const key in datatable){
          manager.push(datatable[key])
         // console.log('datatable[key].family',datatable[key].family)
          for(const key1 in datatable[key].family){
              //console.log('datatable[key].family[key1]',datatable[key].family[key1].firstname)
              //console.log('datatable[key].family[key1]',datatable[key].family[key1].boss)
              if(datatable[key].family[key1].track.length>0){
                //console.log('track====',datatable[key].family[key1].track)
                for(const key2 in datatable[key].family[key1].track){
                    if(datatable[key].family[key1].track[key2].text1){
                    let goalsProgress=datatable[key].family[key1].track[key2].text
                    goalsProgress=goalsProgress.split(':')[1]
                    let cultureAdd=datatable[key].family[key1].track[key2].text1
                    cultureAdd=cultureAdd.split(':')[1]

                    family.push({
                      name:datatable[key].family[key1].firstname+' '+datatable[key].family[key1].lastname,
                      email:datatable[key].family[key1].email, // Added email here
                      boss:datatable[key].family[key1].boss,
                      createdate:datatable[key].family[key1].track[key2].month,
                      GoalsProgress:datatable[key].family[key1].track[key2].goal_value,
                      goal_value:goalsProgress,
                      cultuerAdd:datatable[key].family[key1].track[key2].culture_value,
                      culture_value:cultureAdd,
                      gem:'Yes',
                      custom_responses:datatable[key].family[key1].custom_responses || [],
                    })
                  }
                }
              }
          }

        }
        manager=_.orderBy(manager, function(dateObj) {return dateObj.GoalsProgress},['desc'])
        family=_.orderBy(family, ['name', 'createdate'], ['desc', 'asc'])

        dispatch('genDataExport',{manager:manager,member:family})
        
        // firebase.firestore().collection('send_review_gem').where("company", "==", rootState.authen.user.company).where('createdate','>=',`${past7month}-01`).get()
        // .then(function (querySnapshot) {
        //   querySnapshot.forEach((doc) => {
        //     const data = doc.data()
        //     dataAll.push(data)
        //   })
   
        //   const  receiver = _.groupBy(dataAll, function (b) {
        //     return b.receiver;
        //   });
        //   let family:Array<any> =[]
        //   for(const emailKey in alluser){
        //     reviewActivity.total++
        //     if(receiver[alluser[emailKey].email]){
        //       const newData =_.orderBy(receiver[alluser[emailKey].email], function(dateObj) {
        //         return new Date(dateObj.date);
        //       },['desc'])
              
        //       if(newData){
        //         alluser[emailKey].totalData=0
        //         alluser[emailKey].track=[]
        //         for(const i in newData){
        //           const lastData=newData[i]
        //           let goalText=''
        //           let cultureText=''
        //           if(lastData.goal){

        //             if(lastData.goal==4){
        //               goalText='Exceeded'
        //             }else if(lastData.goal==3){
        //              goalText='Met'
        //             }else if(lastData.goal==2){
        //               goalText='Partially'
        //             }else if(lastData.goal==1){
        //               goalText='Did not Meet'
        //             }
        //           }
        //           if(lastData.culture){
        //             if(lastData.culture==4){
        //               cultureText='Significantly'
        //             }else if(lastData.culture==3){
        //               cultureText='Consistently'
        //             }else if(lastData.culture==2){
        //               cultureText='Somewhat'
        //             }else if(lastData.culture==1){
        //               cultureText='Rarely'
        //             }
        //           }
  
                 
        //           const _emailKey=alluser[emailKey].boss.replace(/\./g, "||")
        //           if(alluser[_emailKey]&&alluser[emailKey]){
        //             family.push({
        //               name:alluser[emailKey].firstname+' '+alluser[emailKey].lastname,
        //               boss:alluser[_emailKey].firstname+' '+alluser[_emailKey].lastname,
        //               email:alluser[emailKey].email,
        //               emailboss:alluser[_emailKey].email,
        //               createdate:format(new Date(lastData.createdate), 'MMMM YYYY'),
        //               reviewCompleted:'Completed',
        //               GoalsProgress:goalText,
        //               cultuerAdd:cultureText,
        //               gem:lastData.gem?lastData.gem==1?'Yes':'Yes (2)':'No',
        //               goal_value:lastData.goal_value?lastData.goal_value:'',
        //               culture_value:lastData.culture_value?lastData.culture_value:'',
        //               month:format(new Date(lastData.createdate), 'MM YYYY'),
                      
                      
        //             })

        //           }
                  

        //         }
        //       }
        //     }
      
        //   }

        //   let tableData:Array<any>=_.cloneDeep(state.tableDataAll)//state.tableDataAll
        //   if(state.statusTeam==true){
            
        //     let boss_select = _.filter(_boss, function(o) { return o.team==state.valueTeam; });
        //     tableData=_.filter( tableData, function (b) {return b.email==boss_select[0].email;});
        //     family=_.filter( family, function (b) {return b.emailboss==boss_select[0].email;});

        //   }
          
        //   tableData=_.orderBy(tableData, function(dateObj) {return dateObj.GoalsProgress},['desc'])
        //   family=_.orderBy(family, ['name', 'createdate'], ['desc', 'asc'])
          
        //   dispatch('genDataExport',{manager:tableData,member:family})

        // })
      },
      async genDataExport({ commit, state, dispatch, rootState }: any, obj:any) {
        const company = await getCompany(rootState.authen.user.company)
        const header:any = ['','Team Name','']
        const manager= obj.manager
        const member= obj.member
        const Excel = require('exceljs');
        var wb = new Excel.Workbook();
        var ws = wb.addWorksheet('Manager Overview');
        var ws1 = wb.addWorksheet('Employee Performance');
        /*TITLE*/
        ws.getRow(2).height = 20
        ws.getCell('A1').font = { name: 'Arial', size: 12, bold: true }
        ws.getCell('A1').alignment = { vertical: 'middle' }
        ws.getCell('A1').value = `${company.name} Performance Review Data Downloaded on ${format(new Date(),'MMMM DD,YYYY')}`

        // /*Column headers*/
        ws.getColumn('A').width = 25;
        ws.getColumn('B').width = 10;
        ws.getColumn('C').width = 10;
        ws.getColumn('D').width = 10;
        ws.getColumn('E').width = 10;
        ws.getRow(3).values =['Manager','Reviews completed','Goal Progress','Culture Add','Both']
        
        // /*Data*/
        _.forEach(manager, (item, key)=> {
          let _tmp = [
            item.firstname+' '+item.lastname,
            item.reviewCompleted,
            item.GoalsProgress,
            item.cultuerAdd,
            item.both,
          
          ];
          ws.addRow(_tmp);
   
        });


        //sheet2
        /*TITLE*/
        ws1.getRow(2).height = 20
        ws1.getCell('A1').font = { name: 'Arial', size: 12, bold: true }
        ws1.getCell('A1').alignment = { vertical: 'middle' }
        ws1.getCell('A1').value = `${company.name} Performance Review Data Downloaded on ${format(new Date(),'MMMM DD,YYYY')}`

        // /*Column headers*/
        ws1.getColumn('A').width = 25;
        ws1.getColumn('B').width = 10;
        ws1.getColumn('C').width = 10;
        ws1.getColumn('D').width = 10;
        ws1.getColumn('E').width = 10;
        ws1.getColumn('F').width = 25; // Added for Email Address

        // Seed columns from all preset definitions so every defined question gets a column
        const customQuestionMap: any = {}
        const customQuestionOrder: string[] = []
        const allPresets = state.presetlistAll || []
        for (const preset of allPresets) {
          if (preset.custom_questions && preset.custom_questions.length > 0) {
            for (const q of preset.custom_questions) {
              if (!customQuestionMap[q.id]) {
                const section = q.section || 'goal'
                const prefix = section === 'culture' ? '[Culture]' : '[Goal]'
                customQuestionMap[q.id] = `${prefix} ${q.question || ('Q: ' + q.id)}`
                customQuestionOrder.push(q.id)
              }
            }
          }
        }
        // Also pick up any question IDs from responses not in current presets (historical/deleted questions)
        _.forEach(member, (item: any) => {
          if (item.custom_responses && item.custom_responses.length > 0) {
            for (const r of item.custom_responses) {
              if (!customQuestionMap[r.question_id]) {
                const section = r.section || 'goal'
                const prefix = section === 'culture' ? '[Culture]' : '[Goal]'
                customQuestionMap[r.question_id] = `${prefix} ${r.question_text || ('Q: ' + r.question_id)}`
                customQuestionOrder.push(r.question_id)
              }
            }
          }
        })

        const baseHeaders = ['Team Member', 'Email Address', 'Manager','Month Completed','Goal Progress','Feedback','Culture Add','Feedback','Gem Received']
        const customHeaders = customQuestionOrder.map(id => customQuestionMap[id])
        ws1.getRow(3).values = [...baseHeaders, ...customHeaders]

        // Set width for custom question columns
        const baseColCount = baseHeaders.length
        for (let i = 0; i < customHeaders.length; i++) {
          ws1.getColumn(baseColCount + i + 1).width = 25
        }

        // /*Data*/
        _.forEach(member, (item: any, key: any)=> {
          let _tmp = [
            item.name,
            item.email, // Added email
            item.boss,
            item.createdate,
            item.GoalsProgress,
            item.goal_value,
            item.cultuerAdd,
            item.culture_value,
            item.gem,
          ];

          // Append custom question responses in the same order
          for (const qId of customQuestionOrder) {
            const response = item.custom_responses ? item.custom_responses.find((r: any) => r.question_id === qId) : null
            _tmp.push(response ? String(response.value) : '')
          }

          ws1.addRow(_tmp);

        });

        
        wb.xlsx.writeBuffer( {
          base64: true
        })
        .then( function (xls64) {
            // build anchor tag and attach file (works in chrome)
            var a = document.createElement("a");
            var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

            var url = URL.createObjectURL(data);
            a.href = url;
            a.download = 'Performance' + ".xlsx";
            document.body.appendChild(a);
            a.click();
            setTimeout(function() {
               
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                },
                0);
        })
        .catch(function(error) {
            console.log(error.message);
        });
      },
      async getPresets({commit,state,dispatch,rootState}:any){
        //console.log("getPresets")
        commit('setloading_preset',true)
        try {
        let memberInteamAll=_.cloneDeep(state.memberInteamAll_master)
        //console.log("memberInteamAll",memberInteamAll)
        const preset_list:Array<any>=[]
        const team_all=await getTeamByCompany(rootState.authen.user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        const user_all=await getUserAll(rootState.authen.user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        const boss_all=(await firebase.database().ref(`boss/${rootState.authen.user.company}`).once('value')).val()
        const team_used_preset:Array<any>=[]
        const user_used_preset:Array<any>=[]
        await firebase.firestore().collection('performance_template').where("company", "==", rootState.authen.user.company).get()
        .then(async function (querySnapshot) {
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            data.id=doc.id
            data.focus_preset=false
            //console.log("data",data.teams)
            if(data.teams){
              if(!team_used_preset[data.id]){
                team_used_preset[data.id]=[]
              }
              team_used_preset[data.id].push(...data.teams)
            }
            if(data.users){
              if(!user_used_preset[data.id]){
                user_used_preset[data.id]=[]
              }
              user_used_preset[data.id].push(...data.users)
            }
            
            preset_list.push(data)
          })
          const member_groupbyteam:any=_.groupBy(user_all, function (b) {
            return b.team;
          });
          
          
          for(const item of preset_list){
            
            item.total_assignments=0
            item.data_users=[]
            item.data_team=[]
            if(item.users){
              for(const x of item.users){
                const emailKey=x.replace(/\./g, "||")
                const user:any={}
                if(user_all[emailKey]){
                  user.email=user_all[emailKey].email
                  user.firstname=user_all[emailKey].firstname
                  user.lastname=user_all[emailKey].lastname
                  user.boss=user_all[emailKey].boss
                  user.team=user_all[emailKey].team
                  user.team_name=team_all[user_all[emailKey].team]?team_all[user_all[emailKey].team].name:''
                  user.profilepic_crop=user_all[emailKey].profilepic_crop
                  item.data_users.push(user)
                }
                item.total_assignments+=1
                for(const key in memberInteamAll){
                  const _user=_.filter(memberInteamAll[key].users, function(o) { return o.email!==user.email });
                  if(_user&&_user.length>0){
                    //console.log("memberInteamAll",_user)
                    // const _member=_.find(memberInteamAll[key].users, function(o) { return o.email==user.email });
                    _user.preset_name=item.name
                    memberInteamAll[key].users=_user
                  }
                }


              }

            }
            
            if(item.teams){
              for(const team of item.teams){
                
                const organization1level=state.organization1level[team]
                const team_data=team_all[team]
                let memberbyteem=0
                if(organization1level){
                  for(const team_id in organization1level){

                    if(member_groupbyteam[team_id]){
                      for(const user of member_groupbyteam[team_id]){
                        
                        //check user used preset
                        for(const id_preset in user_used_preset){
                          const _finduser=_.find(user_used_preset[id_preset], function(o) { return o==user.email });
                          if(_finduser){
                              user.user_preset_id=id_preset
                              
                          }
                        }
                        for(const id_preset in team_used_preset){
                          const _findteam=_.find(team_used_preset[id_preset], function(o) { return o==user.team });
                            if(_findteam){
                              if(!user.user_preset_id){
                                user.team_preset_id=id_preset
                              }
                              // user team
                              for(const key in memberInteamAll){
                                const _user=_.filter(memberInteamAll[key].users, function(o) { return o.email==user.email });
                                if(_user&&_user.length>0&&key!==user.team){
                                  const _user_team=_.filter(memberInteamAll[key].users, function(o) { return o.email!==user.email });
                                  memberInteamAll[key].users=_user_team
                                  
                             
                                }
                              }

                            }



                          }
                              if(!user.team_preset_id&&!user.user_preset_id){
                             
                                //console.log("id_prese!!!!!!!!!",id_preset)
                                const emailkey_boss=user.boss.replace(/\./g, "||")
                                  
                                const temp_team=boss_all[emailkey_boss].team

                                
                                
                              
                                const checkteam_preset=await dispatch('checkTeamUsed',{user_email:user.email,boss_email:user.boss,team:temp_team,alluser:user_all,boss_all:boss_all,team_used_preset:team_used_preset})
                             

                                
                                  const _user=_.filter(memberInteamAll[team].users, function(o) { return o.email==user.email });
                                  if(_user&&_user.length>0&&team!==(checkteam_preset&&checkteam_preset.team_id)){
                                    const _user_team=_.filter(memberInteamAll[team].users, function(o) { return o.email!==user.email });
                                    memberInteamAll[team].users=_user_team                              
                                  }

                                
                                

                                


                                if(checkteam_preset&&checkteam_preset.id_preset==item.id){
                                  
                                  
                                  memberbyteem+=1
                                  item.total_assignments+=1
                                }
                              }else if(user.team_preset_id==item.id){
                                memberbyteem+=1
                                item.total_assignments+=1

                              }
                          //}

                        }
                    }




                    // }
                  }
                  if(team_data){
                    team_data.membersteams=memberbyteem
                    team_data.id=team
                    item.data_team.push(team_data)
                  }
                }else{
                  const team_data=team_all[team]
                  if(member_groupbyteam[team]){
                    if(team_data){
                      team_data.membersteams=member_groupbyteam[team].length
                      item.total_assignments+=member_groupbyteam[team].length
                      team_data.id=team
                      item.data_team.push(team_data)
                    }
                    
                  }
                  
                }
              }
            }

            
          }
         
          memberInteamAll=_.orderBy(memberInteamAll, 'name', 'asc')
          commit('setMemberInteam',memberInteamAll)
          commit('setMemberInteamAll',memberInteamAll)
          commit('setpresetlistAll',preset_list)
          commit('setpresetlist',preset_list)
          commit('setloading_preset',false)
        })
        } catch (error) {
          console.error('getPresets error:', error)
          commit('setloading_preset',false)
        }
      },
      async getmemberInteam({commit,state,dispatch,rootState}:any, value:any){
        commit('setloading_preset',true)
        try {
        const organization1level:any={}
        let user_all=await getUserAll(rootState.authen.user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        const group_memberinteam:any=_.groupBy(user_all, function (b) {
          return b.team;
        });
        
        const team_all=await getTeamByCompany(rootState.authen.user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        const memberinteam_all:any={}
        let memberinteam:any={}
        const organization1level_master=_.cloneDeep(state.organization1level_master)
        // await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
        //     .then((querySnapshot)=> {
        //             querySnapshot.forEach((doc)=> {
                      for(const key in organization1level_master){
                        const data=organization1level_master[key]
                        if(!organization1level[data.team_id]){
                          organization1level[data.team_id]=data.parent
                        }
                        if(!memberinteam_all[data.team_id]){
                          memberinteam_all[data.team_id]={users:[],name:team_all[data.team_id]?team_all[data.team_id].name:'',id:data.team_id}
                        }
                        if(!memberinteam[data.team_id]){
                          memberinteam[data.team_id]={users:[],name:team_all[data.team_id]?team_all[data.team_id].name:'',id:data.team_id}
                        }
                        if(data.parent){
                          for(const key  in data.parent){
                           
                       
                            if(group_memberinteam[key]){
                              memberinteam_all[data.team_id].users.push(...group_memberinteam[key])
                              memberinteam[data.team_id].users.push(...group_memberinteam[key])
                            }
                          }
                          
                        }   

                      }
                    
                                      
                    // });
                    for(const key in team_all){
                      if(!memberinteam_all[key]){
                        if(group_memberinteam[key]){
                          memberinteam_all[key]={users:group_memberinteam[key],name:team_all[key].name,id:key}
                        }
                      }
                      if(!memberinteam[key]){
                        if(group_memberinteam[key]){  
                          memberinteam[key]={users:group_memberinteam[key],name:team_all[key].name,id:key}
                        }
                      }
                    }
                    //console.log("memberinteam",memberinteam)
                    memberinteam=_.orderBy(memberinteam, 'name', 'asc')
                    commit('setOrganization1level', organization1level)
                    commit('setMemberInteam', memberinteam)
                    commit('setMemberInteamMaster', memberinteam_all)
                    commit('setMemberInteamAll', memberinteam_all)
                    for(const key in user_all){
                      user_all[key].team_name=team_all[user_all[key].team].name
                    }
                    user_all=_.orderBy(user_all, 'firstname', 'asc')
                    commit('setAllUser', user_all)
                    commit('setMember', user_all)
                    commit('setloading', false)
                    dispatch('getPresets')
            // });
        } catch (error) {
          console.error('getmemberInteam error:', error)
          commit('setloading_preset',false)
        }
      },
      async updateAndCreatePreset({commit,state,dispatch,rootState}:any, value:any){
        //console.log('updateAndCreatePreset',value)
        commit('setloading_preset',true)
        const preset_form=_.cloneDeep(value.preset)
        const duplicate=_.cloneDeep(value.duplicate)
        
        for(const key in duplicate){
          if(duplicate[key].status_duplicate_team==true&&duplicate[key].status_duplicate_user==true){
            const team:any=[]
            const user:any=[]
            const newId=duplicate[key].id
            if(duplicate[key].team){
              for(const i in duplicate[key].team){
                team.push(duplicate[key].team[i])
              }
            }
            if(duplicate[key].users){
              for(const i in duplicate[key].users){
                user.push(duplicate[key].users[i])
              }
            } 
            const data:any={
              users:user,
              teams:team,
              modified_at:format(new Date(),'YYYY-MM-DD HH:mm:ss')
            }
            await firebase.firestore().collection('performance_template').doc(newId).update(data)

          }
          else if(duplicate[key].status_duplicate_team==true){
            const team:any=[]
            const newId=duplicate[key].id
            if(duplicate[key].team){
              for(const i in duplicate[key].team){
           
                team.push(duplicate[key].team[i])
              }
            }

            const data:any={
              teams:team,
              modified_at:format(new Date(),'YYYY-MM-DD HH:mm:ss')
            }
            await firebase.firestore().collection('performance_template').doc(newId).update(data)
          }else if(duplicate[key].status_duplicate_user==true){
            const user:any=[]
            const newId=duplicate[key].id
            if(duplicate[key].users){
              for(const i in duplicate[key].users){
                user.push(duplicate[key].users[i])
              }
            } 
            const data:any={
              users:user,
              modified_at:format(new Date(),'YYYY-MM-DD HH:mm:ss')
            }
            await firebase.firestore().collection('performance_template').doc(newId).update(data)
          }
        }
        let user:any=[]
        let team:any=[]
        if(preset_form.users){
          for(const i in preset_form.users){
            //console.log("i",i)
            user.push(preset_form.users[i].email)
          }
        }
        if(preset_form.team){
          for(const i in preset_form.team){

            team.push(preset_form.team[i].id)
          }
        }
       // console.log("user",user)
        let newId=''
        const fullLabels = (labels: any, defaults: Record<number, string>) => {
          const merged: any = { ...defaults }
          if (labels) {
            for (const k of Object.keys(defaults)) {
              const val = labels[k] && labels[k].trim ? labels[k].trim() : ''
              if (val) merged[k] = val
            }
          }
          return merged
        }

        const data:any={
          name:preset_form.name,
          users:user,
          company:rootState.authen.user.company,
          goals:preset_form.goals,
          culture:preset_form.culture,
          teams:team,
          modified_by:rootState.authen.user.email,
          next_review:preset_form.next_review,
          status:true,
          goal_question:preset_form.goal_question || DEFAULT_GOAL_QUESTION,
          goal_labels:fullLabels(preset_form.goal_labels, DEFAULT_GOAL_LABELS),
          culture_question:preset_form.culture_question || DEFAULT_CULTURE_QUESTION,
          culture_labels:fullLabels(preset_form.culture_labels, DEFAULT_CULTURE_LABELS),
          custom_questions:preset_form.custom_questions && preset_form.custom_questions.length > 0 ? preset_form.custom_questions : [],
        }
        if(!preset_form.team){
          delete data.teams
        }
        if(!preset_form.users){
          //console.log("preset_form.users",preset_form.users)
          delete data.users
        }
        
        try {
        if(preset_form.preset_id){

          newId=preset_form.preset_id
          data.modified_at=format(new Date(),'YYYY-MM-DD HH:mm:ss')
          await firebase.firestore().collection('performance_template').doc(newId).update(data)
          //.log('update preset success')
        }else{

          //console.log('create preset')
          data.created_at=format(new Date(),'YYYY-MM-DD HH:mm:ss')
          await firebase.firestore().collection('performance_template').doc().set(data) 
      
          //console.log('create preset success')
        }
        dispatch('getPresets')
        } catch (error) {
          //console.error('Error updating or creating preset:', error)
        }
       
        

      },
      async checkTeamUsed({state,rootState,dispatch}:any, value:any){
        
        const user_all=value.alluser
        const boss_all=value.boss_all
        const user_email=value.user_email
        const boss_email=value.boss_email
        const team_id=value.team
        const team_used_preset=value.team_used_preset
        for(const id_preset in team_used_preset){
          
          if(team_id!=''){
          const _findteam=_.find(team_used_preset[id_preset], function(o) { return o==team_id });
            if(_findteam){
    
              return {id_preset:id_preset,team_id:team_id}
            }
          }
        }
        const emailkey = boss_email.replace(/\./g, "||")
        if (user_all[emailkey] && user_all[emailkey].boss) {
        const emailkey=boss_email.replace(/\./g, "||")
        const temp_boss=user_all[emailkey].boss
        const emailkey_boss=user_all[emailkey].boss.replace(/\./g, "||")
        const temp_team=user_all[emailkey_boss].team
        if (temp_team) {
          return await dispatch('checkTeamUsed',{user_email:user_email,boss_email:temp_boss,team:temp_team,alluser:user_all,boss_all:boss_all,team_used_preset:team_used_preset})
        }
        }
      },
      async deletePreset({commit,state,dispatch,rootState}:any, value:any){
        //console.log('deletePreset',value)
        await firebase.firestore().collection('performance_template').doc(value.preset_id).delete()
        dispatch('getPresets')
      },
      async searchmemberandteamandMember({commit,state,dispatch,rootState}:any, value:any){
        //console.log('searchmemberandteam',value)
        const type=value.type
        let memberinteam:any={}
        var re = new RegExp(value.value, 'gi')
        if(type=='team'){
          
          const _memberinteam:any=_.cloneDeep(state.memberInteamAll)
          if (value.value) {
            for(const key in _memberinteam){
              if(_memberinteam[key].name.match(re)){
                memberinteam[key]=_memberinteam[key]
              }
            }
            //console.log("memberinteam",memberinteam)
            memberinteam=_.orderBy(memberinteam, 'name', 'asc')
            commit('setMemberInteam', memberinteam)
          }else{
            commit('setMemberInteam', state.memberInteamAll)
          }
        }
        else{
          const _memberinteam:any=_.cloneDeep(state.allUser)
          if (value.value) {
            for(const key in _memberinteam){
              //console.log("key",_memberinteam[key].firstname)
              if(_memberinteam[key].firstname.match(re)){
                memberinteam[key]=_memberinteam[key]
              }else if(_memberinteam[key].lastname.match(re)){
                memberinteam[key]=_memberinteam[key]
              }else if(_memberinteam[key].email.match(re)){
                memberinteam[key]=_memberinteam[key]
              }else if(_memberinteam[key].team_name.match(re)){
                memberinteam[key]=_memberinteam[key]
              }
            }
            //console.log("memberinteam",memberinteam)
            memberinteam=_.orderBy(memberinteam, 'firstname', 'asc')
            commit('setMember', memberinteam)
          }else{
            commit('setMember', state.allUser)
          }
        }
      },
      async searchData_preset({commit,state,dispatch,rootState}:any, value:any){
        //.log('searchData_preset',value)
        var re = new RegExp(value, 'gi') 
        const presetlistAll:any=_.cloneDeep(state.presetlistAll)
        //console.log("presetlistAll",presetlistAll)
        const presetlist:any=[]
        if (value) {
          for(const key in presetlistAll){
            //console.log("presetlistAll[key].name",presetlistAll[key].name)
            if(presetlistAll[key].name.match(re)){
              presetlist.push(presetlistAll[key])
            }
            else if(presetlistAll[key].goals.match(re)){
              presetlist.push(presetlistAll[key])
            }
            else if(presetlistAll[key].culture.match(re)){
              presetlist.push(presetlistAll[key])
            }
            else if(presetlistAll[key].next_review.match(re)){
              presetlist.push(presetlistAll[key])
            }
          }
          //console.log("presetlist",presetlist)
         commit('setpresetlist', presetlist)
        }else {
          commit('setpresetlist', presetlistAll)
        }
       
      },
      async deleteReview({commit,state,dispatch,rootState}:any, value:any){
        commit('setloading',true)
        commit('settableData',[])
        //console.log('value',value) 
        let gem=value.employeegem
        let got_gem_lastdate=''
        let update_gem={}
        

        await firebase.firestore().collection('send_review_gem').doc(value.reviewId).get().then(async (doc)=>{
          if(doc.exists){
            console.log('value.employeeId',doc.data())
            const data=doc.data()
            if(data){
              gem=gem-(data.gem?data.gem:0)
              
              
              if(format(data.createdate,'YYYY-MM')==format(new Date(),'YYYY-MM')){
                 got_gem_lastdate=format(addDays(data.createdate,-30),'YYYY-MM-DD HH:mm:ss')
                 update_gem={
                  gem:gem,
                  got_gem_lastdate:got_gem_lastdate
                }
              }else{
                update_gem={gem:gem}
              }
              //console.log('update_gem',update_gem)
              await firebase.database().ref(`/users/${value.employeeId}`).update(update_gem).then(()=>{
                dispatch('authen/addLogs',{
                  company:rootState.authen.user.company,
                  createdate:format(new Date(),'YYYY-MM-DD HH:mm:ss'),
                  table:'users',
                  status:'update_gem',
                  before_gem:value.employeegem,
                  id:value.employeeId,
                  user:rootState.authen.user.email
                },{root:true})
              })
            }
          }
       })

        await firebase.firestore().collection('develop_skills').where("review_id","==",value.reviewId).get().then((querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            //console.log('develop_skills',doc.id,doc.data())
            await firebase.firestore().collection('develop_skills').doc(doc.id).delete().then(()=>{
              dispatch('authen/addLogs',{
                company:rootState.authen.user.company,
                createdate:format(new Date(),'YYYY-MM-DD HH:mm:ss'),
                table:'develop_skills',
                status:'delete',
                id:doc.id,
                user:rootState.authen.user.email
              },{root:true})
            }).catch((error)=>{
              console.log('delete error',error)
            })
          })
        })
        await firebase.firestore().collection('spark_class_ai').where("id","==",value.reviewId).get().then((querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            //console.log('spark_class_ai',doc.id,doc.data())
            await firebase.firestore().collection('spark_class_ai').doc(doc.id).delete().then(()=>{
              dispatch('authen/addLogs',{
                company:rootState.authen.user.company,
                createdate:format(new Date(),'YYYY-MM-DD HH:mm:ss'),
                table:'spark_class_ai',
                id:doc.id,
                status:'delete',
                user:rootState.authen.user.email
              },{root:true})
            }).catch((error)=>{
              console.log('delete error',error)
            })
          })
        })
        await firebase.firestore().collection('messages').where("id_review","==",value.reviewId).get().then((querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            //console.log('messages',doc.id,doc.data())
            await firebase.firestore().collection('messages').doc(doc.id).delete().then(()=>{
              dispatch('authen/addLogs',{
                company:rootState.authen.user.company,
                createdate:format(new Date(),'YYYY-MM-DD HH:mm:ss'),
                table:'messages',
                id:doc.id,
                status:'delete',
                user:rootState.authen.user.email
              },{root:true})
            }).catch((error)=>{
              console.log('delete error',error)
            })
          })
        })
        await firebase.firestore().collection('here_point').where("review_id","==",value.reviewId).get().then((querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            //console.log('performance_review',doc.id,doc.data())
            await firebase.firestore().collection('here_point').doc(doc.id).delete().then(()=>{
              dispatch('authen/addLogs',{
                company:rootState.authen.user.company,
                createdate:format(new Date(),'YYYY-MM-DD HH:mm:ss'),
                table:'here_point',
                status:'delete',
                id:doc.id,
                user:rootState.authen.user.email
              },{root:true})
            }).catch((error)=>{
              console.log('delete error',error)
            })
          })
        })
        
        await firebase.firestore().collection('send_review_gem').doc(value.reviewId).delete().then(()=>{
          dispatch('authen/addLogs',{
            company:rootState.authen.user.company,
            id:value.reviewId,
            createdate:format(new Date(),'YYYY-MM-DD HH:mm:ss'),
            table:'send_review_gem',
            status:'delete',
            user:rootState.authen.user.email
          },{root:true})
        }).catch((error)=>{
          console.log('delete error',error)
        })
        dispatch('getSendReviewGem',value.team)

      },
      async ensureGoalsLoaded({ dispatch, rootGetters }: any) {
        const goalsTeamAI = rootGetters['goals/goalsTeamAI'] || {};
        if (Object.keys(goalsTeamAI).length === 0) {
          await dispatch('goals/getGoalsTeamAI', null, { root: true });
        }
      },
    },

    getters: {
      datachart : (state:any) => {
        return state.datachart
      },
      reviewActivity: (state:any) => {
        return state.reviewActivity
      },
      avg: (state:any) => {
        return state.avg
      },
      ChartGoalandCuture: (state:any) => {
        return state.ChartGoalandCuture
      },
      tableData: (state:any) => {
        return state.tableData
      },
      team: (state:any) => {
        return state.datateam
      },
      loading: (state:any) => {
        return state.loading
      },
      presetlist: (state:any) => {
        //console.log("state.presetlist",state.presetlist)
        return state.presetlist
      },
      memberInteamAll: (state:any) => {
        return state.memberInteamAll
      },
      memberInteam: (state:any) => {
        return state.memberInteam
      },
      member: (state:any) => {
        return state.member
      },
      loading_preset: (state:any) => {
        return state.loading_preset
      },
      presetlistAll: (state:any) => {
        return state.presetlistAll
      },
      organization: (state:any) => {
        return state.organization
      },
      teams: (state:any) => {
        return state.teams
      },
      activeName: (state:any) => {
        return state.activeName
      },
      renderComponent: (state:any) => {
        return state.renderComponent
      },
      /**
       * Get active team goals for a preset's assigned teams
       * Returns goals grouped by team for display in review form
       */
      presetTeamGoals: (state: any, getters: any, rootState: any, rootGetters: any) => (presetId: string) => {
        const presets = state.presetlistAll || [];
        const preset = presets.find((p: any) => p.id === presetId);
        if (!preset || !preset.teams || preset.teams.length === 0) return [];

        const goalsTeamAI = rootGetters['goals/goalsTeamAI'] || {};
        const allTeams = rootGetters['team/teamsall'] || [];
        const result: any[] = [];

        for (const teamId of preset.teams) {
          const teamGoals = goalsTeamAI[teamId] || [];
          const activeGoals = teamGoals.filter((g: any) => !g.archived);
          if (activeGoals.length > 0) {
            const team = allTeams.find((t: any) => t.key === teamId);
            result.push({
              teamId,
              teamName: team ? team.name : 'Unknown Team',
              teamColor: team ? (team.color || '#747474') : '#747474',
              goals: activeGoals.map((g: any) => ({
                goal_id: g.goal_id,
                quick_preview: g.quick_preview,
                goal_description: g.goal_description,
                key_results: g.key_results || [],
              })),
            });
          }
        }
        return result;
      },
      /**
       * Get active goals relevant to a specific team member
       * Used when a manager is reviewing a specific person
       */
      goalsForReviewee: (state: any, getters: any, rootState: any, rootGetters: any) => (memberEmail: string) => {
        const goalsTeamAI = rootGetters['goals/goalsTeamAI'] || {};
        const allTeams = rootGetters['team/teamsall'] || [];

        // Find the member's team from the member data in state
        const memberInteamAll = state.memberInteamAll || {};
        let memberTeamId = '';

        for (const teamId of Object.keys(memberInteamAll)) {
          const teamData = memberInteamAll[teamId];
          if (teamData && teamData.data) {
            const member = teamData.data.find((m: any) => m.email === memberEmail);
            if (member) {
              memberTeamId = teamId;
              break;
            }
          }
        }

        if (!memberTeamId) return [];

        const teamGoals = goalsTeamAI[memberTeamId] || [];
        const activeGoals = teamGoals.filter((g: any) => !g.archived);
        const team = allTeams.find((t: any) => t.key === memberTeamId);

        return activeGoals.map((g: any) => ({
          goal_id: g.goal_id,
          quick_preview: g.quick_preview,
          goal_description: g.goal_description,
          key_results: g.key_results || [],
          my_key_results: (g.key_results || []).filter(
            (kr: any) => kr.owner_emails && kr.owner_emails.includes(memberEmail)
          ),
          teamName: team ? team.name : '',
          teamColor: team ? (team.color || '#747474') : '#747474',
        }));
      },
      krsForReviewee: (state: any, getters: any, rootState: any, rootGetters: any) => (memberEmail: string) => {
        if (!memberEmail) return [];
        const goalsTeamAI = rootGetters['goals/goalsTeamAI'] || {};
        const result: any[] = [];

        for (const teamId of Object.keys(goalsTeamAI)) {
          const teamGoals = goalsTeamAI[teamId] || [];
          for (const goal of teamGoals) {
            if (goal.archived) continue;
            const krs = goal.key_results || [];
            for (const kr of krs) {
              if (kr.owner_emails && kr.owner_emails.includes(memberEmail)) {
                result.push({
                  goal_id: goal.goal_id,
                  goal_title: goal.quick_preview,
                  team_id: teamId,
                  kr: { ...kr },
                });
              }
            }
          }
        }
        return result;
      },
    }
  }
